/* 🤖 this file was generated by svg-to-ts */
export const civicAdverseresponseOutline: {
  name: 'adverseresponseOutline'
  data: string
} = {
  name: 'adverseresponseOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M547.9 164.3c0-35.6-45.9-49.1-66.1-19.5C296.3 416 559.9 428.2 559.9 560c0 53.4-43.6 96.6-97.1 95.9-52.7-.7-94.6-44.6-94.6-97.3V430.4c0-32.5-39.6-48.3-62.1-24.7-40.1 42.1-81.7 114.3-81.7 202.2 0 158.6 129 287.6 287.6 287.6s287.6-129 287.6-287.6c0-255.1-251.7-289.1-251.7-443.6"/></svg>`,
}
export const civicBenignOutline: {
  name: 'benignOutline'
  data: string
} = {
  name: 'benignOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M868.6 786.3H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.1-12.2-27.4-27.3-27.4m0-219.4H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.2-12.2-27.4-27.3-27.4m0-219.5H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.1-12.2-27.4-27.3-27.4m0-219.4H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.1-12.2-27.4-27.3-27.4"/></svg>`,
}
export const civicBetteroutcomeOutline: {
  name: 'betteroutcomeOutline'
  data: string
} = {
  name: 'betteroutcomeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M194.5 568.3 157.2 531c-15.8-15.8-15.8-41.3 0-56.9l326.3-326.5c15.8-15.8 41.3-15.8 56.9 0l326.3 326.3c15.8 15.8 15.8 41.3 0 56.9l-37.3 37.3c-16 16-42 15.6-57.6-.7L579.3 365.3v482.6c0 22.3-18 40.3-40.3 40.3h-53.7c-22.3 0-40.3-18-40.3-40.3V365.3L252.1 567.6c-15.6 16.5-41.6 16.8-57.6.7"/></svg>`,
}
export const civicCombinationOutline: {
  name: 'combinationOutline'
  data: string
} = {
  name: 'combinationOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M866 771c-35.3 60.7-113.1 81.3-173.8 46s-81.3-113.1-46-173.8 113.1-81.3 173.8-46 81.3 113.1 46 173.8M270.8 642.6c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64m0-64c70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128 57.3-128 128-128m368.9-289.3c0 70-56.7 126.7-126.7 126.7s-126.7-56.7-126.7-126.7S443 162.6 513 162.6s126.7 56.7 126.7 126.7"/></svg>`,
}
export const civicCombinedOutline: {
  name: 'combinedOutline'
  data: string
} = {
  name: 'combinedOutline',
  data: `<svg viewBox="0 0 1024 1024"><ellipse cx="239.9" cy="512" rx="111.9" ry="111.5"/><path d="M239.9 192c26.6 0 47.9 21.3 47.9 47.5S266.5 287 239.9 287 192 265.7 192 239.5s21.3-47.5 47.9-47.5m0-64C178.1 128 128 177.9 128 239.5S178.1 351 239.9 351s111.9-49.9 111.9-111.5S301.8 128 239.9 128M239.9 737c26.6 0 47.9 21.3 47.9 47.5S266.5 832 239.9 832 192 810.7 192 784.5s21.3-47.5 47.9-47.5m0-64C178.1 673 128 722.9 128 784.5S178.1 896 239.9 896s111.9-49.9 111.9-111.5S301.8 673 239.9 673"/><ellipse cx="784.1" cy="512" rx="111.9" ry="111.5"/><path d="M784.1 192c26.6 0 47.9 21.3 47.9 47.5S810.7 287 784.1 287s-47.9-21.3-47.9-47.5 21.3-47.5 47.9-47.5m0-64c-61.9 0-111.9 49.9-111.9 111.5S722.2 351 784.1 351 896 301.1 896 239.5 845.9 128 784.1 128M784.1 737c26.6 0 47.9 21.3 47.9 47.5S810.7 832 784.1 832s-47.9-21.3-47.9-47.5 21.3-47.5 47.9-47.5m0-64c-61.9 0-111.9 49.9-111.9 111.5S722.2 896 784.1 896 896 846.1 896 784.5 845.9 673 784.1 673M512 464.5c26.6 0 47.9 21.3 47.9 47.5s-21.3 47.5-47.9 47.5-47.9-21.3-47.9-47.5 21.3-47.5 47.9-47.5m0-64c-61.9 0-111.9 49.9-111.9 111.5s50 111.5 111.9 111.5S623.9 573.6 623.9 512 573.8 400.5 512 400.5"/><ellipse cx="512" cy="239.5" rx="111.9" ry="111.5"/><ellipse cx="512" cy="784.5" rx="111.9" ry="111.5"/></svg>`,
}
export const civicCommongermlineOutline: {
  name: 'commongermlineOutline'
  data: string
} = {
  name: 'commongermlineOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M336.1 400.5C398 400.5 448 450.4 448 512s-50.1 111.5-111.9 111.5S224.2 573.6 224.2 512s50-111.5 111.9-111.5m-111.9-161c0 61.6 50.1 111.5 111.9 111.5S448 301.1 448 239.5 397.9 128 336.1 128s-111.9 49.9-111.9 111.5m0 545c0 61.6 50.1 111.5 111.9 111.5S448 846.1 448 784.5 397.9 673 336.1 673s-111.9 49.9-111.9 111.5m463.7-384c61.9 0 111.9 49.9 111.9 111.5s-50.1 111.5-111.9 111.5S576 573.6 576 512s50.1-111.5 111.9-111.5M576 239.5c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S749.8 128 687.9 128 576 177.9 576 239.5m0 545c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S749.8 673 687.9 673 576 722.9 576 784.5"/></svg>`,
}
export const civicDiagnosticOutline: {
  name: 'diagnosticOutline'
  data: string
} = {
  name: 'diagnosticOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M911.9 811.8 751.8 651.7c-7.2-7.2-17-11.2-27.3-11.2h-26.2c44.3-56.7 70.7-128 70.7-205.6 0-184.5-149.5-334-334-334s-334 149.5-334 334 149.5 334 334 334c77.6 0 148.9-26.3 205.6-70.7v26.2c0 10.3 4 20.1 11.2 27.3l160.1 160.1c15.1 15.1 39.5 15.1 54.4 0l45.4-45.4c15.2-15.1 15.2-39.5.2-54.6M434.9 690C294 690 179.8 576 179.8 434.9c0-140.9 114-255.1 255.1-255.1 140.9 0 255.1 114 255.1 255.1.1 140.9-113.9 255.1-255.1 255.1"/></svg>`,
}
export const civicDoesnotsupportOutline: {
  name: 'doesnotsupportOutline'
  data: string
} = {
  name: 'doesnotsupportOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M885.9 402.1c4.4-35.8-6-72.8-26-100.5-1.4-83.9-53.7-143-169.4-143h-33.3c-154.1 0-199.9 58.4-266.7 59.9-5.4-20.7-24.1-35.9-46.5-35.9h-96c-26.5 0-48 21.5-48 48v360c0 26.5 21.5 48 48 48h148.1c28.7 25.4 69 91 103.1 125.1 20.5 20.5 15.2 162.9 107.6 162.9 145.9 0 161.2-144.7 129.6-226.9h54.7c95.1 0 165.4-106.2 108.1-203.1 7.2-34 1.5-66.8-13.3-94.5m-79.1 13.7c32.4 30.6 28 76.6 7.8 98.4 14.2 0 33.5 28.4 33.4 56.7-.1 28.4-25.1 56.7-56.7 56.7h-156c0 56.7 42.5 83.1 42.5 141.8 0 35.6 0 85.1-70.9 85.1-28.4-28.4-14.2-99.3-56.7-141.8-39.8-39.9-99.3-146.2-141.8-146.2H392V287.3c80.4 0 150-56.7 257.5-56.7 61.4 0 154.1-13.2 136.4 98.8 22.8 12.3 39.7 54.7 20.9 86.4M296 314.6c-19.9 0-36-16.1-36-36s16.1-36 36-36 36 16.1 36 36-16.1 36-36 36"/></svg>`,
}
export const civicDominantnegativeOutline: {
  name: 'dominantnegativeOutline'
  data: string
} = {
  name: 'dominantnegativeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M433.9 664.9c37.4 0 56.2 45.2 29.7 71.7L313 887.2c-16.4 16.4-43 16.4-59.4 0L103 736.6c-26.5-26.5-7.7-71.7 29.7-71.7h80.6V150c0-15.7 12.7-28.3 28.3-28.3h83.3c15.7 0 28.3 12.7 28.3 28.3v514.9zm457.4 0h-80.6V150c0-15.7-12.7-28.3-28.3-28.3h-83.3c-15.7 0-28.3 12.7-28.3 28.3v514.9h-80.6c-37.4 0-56.2 45.2-29.7 71.7L711 887.2c16.4 16.4 43 16.4 59.4 0L921 736.6c26.4-26.5 7.7-71.7-29.7-71.7"/></svg>`,
}
export const civicFunctionalOutline: {
  name: 'functionalOutline'
  data: string
} = {
  name: 'functionalOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m929.9 619.7-77-44.4c7.8-41.9 7.8-84.9 0-126.8l77-44.4c8.9-5.1 12.8-15.5 9.9-25.3-20.1-64.3-54.2-122.5-98.8-170.9-6.9-7.4-18.1-9.2-26.7-4.2l-77 44.4c-32.3-27.8-69.5-49.3-109.8-63.4V96c0-10.1-7-19-17-21.1-66.3-14.8-134.2-14.1-197.3 0-9.9 2.2-17 11-17 21.1v88.9c-40.1 14.3-77.3 35.8-109.8 63.4l-76.8-44.4c-8.9-5.1-19.9-3.4-26.7 4.2-44.6 48.2-78.8 106.4-98.8 170.9-3.1 9.8 1.1 20.2 9.9 25.3l77 44.4c-7.8 41.9-7.8 84.9 0 126.8l-77 44.4c-8.9 5.1-12.8 15.5-9.9 25.3 20.1 64.3 54.2 122.5 98.8 170.9 6.9 7.4 18.1 9.2 26.7 4.2l77-44.4c32.3 27.8 69.5 49.3 109.8 63.4V928c0 10.1 7 19 17 21.1 66.3 14.8 134.2 14.1 197.3 0 9.9-2.2 17-11 17-21.1v-88.9c40.1-14.3 77.3-35.8 109.8-63.4l77 44.4c8.9 5.1 19.9 3.4 26.7-4.2C885.8 767.7 920 709.5 940 645c2.7-9.8-1.2-20.3-10.1-25.3m-418 36.6c-79.7 0-144.5-64.9-144.5-144.5s64.9-144.5 144.5-144.5 144.5 64.9 144.5 144.5-64.8 144.5-144.5 144.5"/></svg>`,
}
export const civicGainoffunctionOutline: {
  name: 'gainoffunctionOutline'
  data: string
} = {
  name: 'gainoffunctionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 960c247.5 0 448-200.5 448-448S759.5 64 512 64 64 264.5 64 512s200.5 448 448 448m0-809.3c199.6 0 361.3 161.7 361.3 361.3S711.6 873.3 512 873.3 150.7 711.6 150.7 512 312.4 150.7 512 150.7m57.8 570.8V512h121c19.3 0 28.9-23.3 15.4-37L527.4 296.1c-8.5-8.5-22.2-8.5-30.7 0L317.8 475c-13.7 13.7-4 37 15.4 37h121v209.5c0 11.9 9.8 21.7 21.7 21.7h72.3c11.9 0 21.6-9.7 21.6-21.7"/></svg>`,
}
export const civicLevelaOutline: {
  name: 'levelaOutline'
  data: string
} = {
  name: 'levelaOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M645.4 742.9H378.8l-50.7 152H166.4l274.7-738H582l276.2 738H696.6zm-225.5-123h184.5l-92.8-276.5z"/></svg>`,
}
export const civicLevelbOutline: {
  name: 'levelbOutline'
  data: string
} = {
  name: 'levelbOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M246.5 894.9v-738H505c151.8 0 273.2 50.9 273.2 202 0 72.2-38.9 130.2-105.4 155.9 73.7 18.4 122.1 77.3 122.1 162.9 0 153.4-108.1 215.9-261.5 217.2zm152.1-322v200h130.3c66.3 0 114-31.8 114-96.7 0-67.8-35-102.3-104.9-103.3zm0-107c114.1 0 227.6 15.9 227.6-91.7 0-112.5-108-94.3-227.6-94.3z"/></svg>`,
}
export const civicLevelcOutline: {
  name: 'levelcOutline'
  data: string
} = {
  name: 'levelcOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M817.7 648.9c-11.9 164.6-129.8 256-297 256-204.5 0-304.6-153.3-304.6-357.7 0-65.3-2.9-145.2 37.5-232.6 51.4-111 149.2-167.7 269.1-167.7 168.3 0 279.5 93 296 260.5h-152c-7.3-93.8-49.9-135.5-144-135.5-50.7 0-88.6 18.2-113.8 54.5-42.3 61.1-38.8 157.8-38.8 224.6 0 124.7 25.9 229.9 150.5 229.9 89.3 0 137.9-37.7 145-132z"/></svg>`,
}
export const civicLeveldOutline: {
  name: 'leveldOutline'
  data: string
} = {
  name: 'leveldOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M240.7 894.9v-738h227.1c124.7 0 234.2 56.3 294 168.5 40.1 75.3 43.1 140.3 43.1 217.7 0 127.1-51.4 244-161.7 307.2-97.9 56-167.6 44.6-402.5 44.6m152-615v493h73.5c130 0 183.2-94.6 184.5-225.2 0-58 3.6-147.1-46.6-209.7-53.7-66.9-127.3-58.1-211.4-58.1"/></svg>`,
}
export const civicLeveleOutline: {
  name: 'leveleOutline'
  data: string
} = {
  name: 'leveleOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M730 574.9H438.1v198h342.6v122H286v-738h493.7v123H438.1v176H730z"/></svg>`,
}
export const civicLikelybenignOutline: {
  name: 'likelybenignOutline'
  data: string
} = {
  name: 'likelybenignOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M868.6 786.3H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.1-12.2-27.4-27.3-27.4M749.7 566.9H274.3c-10.1 0-18.3 12.3-18.3 27.4v54.9c0 15.1 8.2 27.4 18.3 27.4h475.4c10.1 0 18.3-12.3 18.3-27.4v-54.9c0-15.2-8.2-27.4-18.3-27.4m118.9-219.5H155.4c-15.1 0-27.4 12.3-27.4 27.4v54.9c0 15.1 12.3 27.4 27.4 27.4h713.1c15.1 0 27.4-12.3 27.4-27.4v-54.9c.1-15.1-12.2-27.4-27.3-27.4M749.7 128H274.3c-10.1 0-18.3 12.3-18.3 27.4v54.9c0 15.1 8.2 27.4 18.3 27.4h475.4c10.1 0 18.3-12.3 18.3-27.4v-54.9c0-15.1-8.2-27.4-18.3-27.4"/></svg>`,
}
export const civicLikelyoncogenicOutline: {
  name: 'likelyoncogenicOutline'
  data: string
} = {
  name: 'likelyoncogenicOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M832 240v184H600V240zm-408 0v184H192V240zm408 360v184H600V600zm-408 0v184H192V600zm436-424H572c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36m-408 0H164c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36m408 360H572c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V572c0-19.9-16.1-36-36-36m-408 0H164c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V572c0-19.9-16.1-36-36-36"/></svg>`,
}
export const civicLikelypathogenicOutline: {
  name: 'likelypathogenicOutline'
  data: string
} = {
  name: 'likelypathogenicOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M572 176h288c19.9 0 36 16.1 36 36v240c0 19.9-16.1 36-36 36H572c-19.9 0-36-16.1-36-36V212c0-19.9 16.1-36 36-36m-120 0H164c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36M128 572v240c0 19.9 16.1 36 36 36h288c19.9 0 36-16.1 36-36V572c0-19.9-16.1-36-36-36H164c-19.9 0-36 16.1-36 36m444 276h288c19.9 0 36-16.1 36-36V572c0-19.9-16.1-36-36-36H572c-19.9 0-36 16.1-36 36v240c0 19.9 16.1 36 36 36"/></svg>`,
}
export const civicLossoffunctionOutline: {
  name: 'lossoffunctionOutline'
  data: string
} = {
  name: 'lossoffunctionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.5 64 64 264.5 64 512s200.5 448 448 448 448-200.5 448-448S759.5 64 512 64m0 809.3c-199.6 0-361.3-161.7-361.3-361.3S312.4 150.7 512 150.7 873.3 312.4 873.3 512 711.6 873.3 512 873.3m-57.8-570.8V512h-121c-19.3 0-28.9 23.3-15.4 37l178.8 178.8c8.5 8.5 22.2 8.5 30.7 0L706.2 549c13.7-13.7 4-37-15.4-37h-121V302.5c0-11.9-9.8-21.7-21.7-21.7h-72.3c-11.9 0-21.6 9.7-21.6 21.7"/></svg>`,
}
export const civicMixedOutline: {
  name: 'mixedOutline'
  data: string
} = {
  name: 'mixedOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 400.5c61.9 0 111.9 49.9 111.9 111.5S573.8 623.5 512 623.5 400.1 573.6 400.1 512 450.2 400.5 512 400.5m-111.9-161c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.8 128 512 128s-111.9 49.9-111.9 111.5m0 545c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.8 673 512 673s-111.9 49.9-111.9 111.5m384.4-384.4C722.9 400.1 673 450.2 673 512s49.9 111.9 111.5 111.9S896 573.8 896 512s-49.9-111.9-111.5-111.9m-545 0C177.9 400.1 128 450.2 128 512s49.9 111.9 111.5 111.9S351 573.8 351 512s-49.9-111.9-111.5-111.9"/></svg>`,
}
export const civicMixed: {
  name: 'mixed'
  data: string
} = {
  name: 'mixed',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 400.5c61.9 0 111.9 49.9 111.9 111.5S573.8 623.5 512 623.5 400.1 573.6 400.1 512 450.2 400.5 512 400.5m-111.9-161c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.8 128 512 128s-111.9 49.9-111.9 111.5m0 545c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.8 673 512 673s-111.9 49.9-111.9 111.5m384.4-384.4C722.9 400.1 673 450.2 673 512s49.9 111.9 111.5 111.9S896 573.8 896 512s-49.9-111.9-111.5-111.9m-545 0C177.9 400.1 128 450.2 128 512s49.9 111.9 111.5 111.9S351 573.8 351 512s-49.9-111.9-111.5-111.9"/></svg>`,
}
export const civicNaOutline: {
  name: 'naOutline'
  data: string
} = {
  name: 'naOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M401.4 701.3h-96.8L161.4 449.9v251.4H64v-404h97.4l142.9 251.4V297.3h97.1zM575.7 280 437.8 718.6h79.6L655.6 280zm270.7 345.8H713l-23.3 75.5h-104l148.2-404h91.6l149.3 404H870zm-110.1-75.2h86.8l-43.6-140.1z"/></svg>`,
}
export const civicNegativeOutline: {
  name: 'negativeOutline'
  data: string
} = {
  name: 'negativeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 63.8C264.4 63.8 63.8 264.4 63.8 512S264.4 960.2 512 960.2 960.2 759.6 960.2 512 759.6 63.8 512 63.8m260.2 498.8c0 11.9-9.8 21.7-21.7 21.7h-477c-11.9 0-21.7-9.8-21.7-21.7V461.4c0-11.9 9.8-21.7 21.7-21.7h477.1c11.9 0 21.7 9.8 21.7 21.7v101.2z"/></svg>`,
}
export const civicNeomorphicOutline: {
  name: 'neomorphicOutline'
  data: string
} = {
  name: 'neomorphicOutline',
  data: `<svg viewBox="0 0 1008 1008"><path d="m556.4 237.9 57 57-432.7 432.7c-11.1 11.1-11.1 29 0 40.1l58.9 58.9c11.1 11.1 29 11.1 40.1 0l432.7-432.7 57 57c26.5 26.5 71.7 7.7 71.7-29.7v-213c0-23.2-18.8-42-42-42h-213c-37.4 0-56.2 45.3-29.7 71.7"/></svg>`,
}
export const civicOncogenicOutline: {
  name: 'oncogenicOutline'
  data: string
} = {
  name: 'oncogenicOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m855.4 511.9 77.9-76.3c23.2-22 12.4-61.1-18.1-68.4l-106.2-27 30-105.1c8.5-30.2-20-58.7-50.3-50.3l-105.1 29.9-27.1-106.2c-7.2-30-46.7-41-68.3-18.1L512 169l-76.2-78.5c-21.4-22.6-61.1-12.3-68.3 18.1l-27.1 106.2-105.1-29.9c-30.2-8.5-58.7 20.1-50.3 50.3l30 105-106.2 27.1c-30.5 7.3-41.3 46.4-18.1 68.4l77.9 76.3-77.9 76.3c-23.2 22-12.4 61.1 18.1 68.4L215 683.6l-30 105.1c-8.5 30.2 20 58.7 50.3 50.3l105-30 27.1 106.2c7.5 31.5 46.9 40.7 68.3 18.1l76.2-78 76.2 78c21.2 22.9 61 12.7 68.3-18.1L683.7 809l105.1 29.9c30.2 8.5 58.7-20.1 50.3-50.3l-30.1-105 106.2-27.1c30.5-7.3 41.3-46.4 18.1-68.4z"/></svg>`,
}
export const civicOncogenicityOutline: {
  name: 'oncogenicityOutline'
  data: string
} = {
  name: 'oncogenicityOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 265.9C373.9 265.9 262 376 262 512s111.9 246.1 250 246.1S762 648 762 512 650.1 265.9 512 265.9m-75.7 382.7c-18 18-27.7 31.7-49.6 31.7-38 0-57.5-46.3-30.4-73.4l19.2-19.1c16.8-16.8 44-16.8 60.8.1s16.8 43.9 0 60.7m-30.5-199.7c-21.6 0-30.3-12.5-49.6-31.8-16.8-16.8-16.8-44 .1-60.8 16.8-16.8 44-16.8 60.8.1l19.1 19.2c27.3 27.1 7.5 73.3-30.4 73.3m181.9-73.5 19.2-19.1c16.8-16.8 44-16.8 60.8.1s16.8 44-.1 60.8c-18 18-27.7 31.7-49.6 31.7-37.9-.1-57.4-46.4-30.3-73.5m49.6 304.9c-21.6 0-30.3-12.5-49.6-31.8-16.8-16.8-16.8-44 .1-60.8 16.8-16.8 44-16.8 60.8.1l19.1 19.2c27.2 27.2 7.5 73.3-30.4 73.3m95.9-346.5c-38 0-57.5-46.3-30.4-73.4l65.5-65.4c16.8-16.8 44-16.8 60.8 0s16.8 44 0 60.8c-68.6 68.4-72.6 78-95.9 78m65.4 507.8c-23.4 0-27.5-9.6-95.8-78.1-16.8-16.8-16.8-44 0-60.8s44-16.8 60.8 0l65.4 65.5c27.2 27.2 7.6 73.4-30.4 73.4m-573.2 0c-38 0-57.5-46.3-30.4-73.4l65.5-65.4c16.8-16.8 44-16.8 60.8 0s16.8 44 0 60.8c-68.6 68.5-72.6 78-95.9 78m65.4-507.8c-23.4 0-27.5-9.6-95.8-78.1-16.8-16.8-16.8-44 0-60.8s44-16.8 60.8 0l65.4 65.5c27.1 27.2 7.5 73.4-30.4 73.4"/></svg>`,
}
export const civicOncogenicsignificanceOutline: {
  name: 'oncogenicsignificanceOutline'
  data: string
} = {
  name: 'oncogenicsignificanceOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M288 240v64h-96v-64zm28-64H164c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36m244 304v64h-96v-64zm28-64H436c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V452c0-19.9-16.1-36-36-36m244-176v64h-96v-64zm28-64H708c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36m-300 64v64h-96v-64zm28-64H436c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36M288 480v64h-96v-64zm28-64H164c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V452c0-19.9-16.1-36-36-36m-28 304v64h-96v-64zm28-64H164c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36m516-176v64h-96v-64zm28-64H708c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V452c0-19.9-16.1-36-36-36m-28 304v64h-96v-64zm28-64H708c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36m-300 64v64h-96v-64zm28-64H436c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36"/></svg>`,
}
export const civicOncogenictypeOutline: {
  name: 'oncogenictypeOutline'
  data: string
} = {
  name: 'oncogenictypeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m855.4 511.9 77.9-76.3c23.2-22 12.4-61.1-18.1-68.4l-106.2-27 30-105.1c8.5-30.2-20-58.7-50.3-50.3l-105.1 29.9-27.1-106.2c-7.2-30-46.7-41-68.3-18.1L512 169l-76.2-78.5c-21.4-22.6-61.1-12.3-68.3 18.1l-27.1 106.2-105.1-29.9c-30.2-8.5-58.7 20.1-50.3 50.3l30 105-106.2 27.1c-30.5 7.3-41.3 46.4-18.1 68.4l77.9 76.3-77.9 76.3c-23.2 22-12.4 61.1 18.1 68.4L215 683.6l-30 105.1c-8.5 30.2 20 58.7 50.3 50.3l105-30 27.1 106.2c7.5 31.5 46.9 40.7 68.3 18.1l76.2-78 76.2 78c21.2 22.9 61 12.7 68.3-18.1L683.7 809l105.1 29.9c30.2 8.5 58.7-20.1 50.3-50.3l-30.1-105 106.2-27.1c30.5-7.3 41.3-46.4 18.1-68.4z"/></svg>`,
}
export const civicPathogenicOutline: {
  name: 'pathogenicOutline'
  data: string
} = {
  name: 'pathogenicOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M352 212v120c0 19.9-16.1 36-36 36H164c-19.9 0-36-16.1-36-36V212c0-19.9 16.1-36 36-36h152c19.9 0 36 16.1 36 36m272 360V452c0-19.9-16.1-36-36-36H436c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36m48-360v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V212c0-19.9-16.1-36-36-36H708c-19.9 0-36 16.1-36 36m-48 120V212c0-19.9-16.1-36-36-36H436c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36m-308 84H164c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V452c0-19.9-16.1-36-36-36M128 692v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36H164c-19.9 0-36 16.1-36 36m580-84h152c19.9 0 36-16.1 36-36V452c0-19.9-16.1-36-36-36H708c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36m0 240h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36H708c-19.9 0-36 16.1-36 36v120c0 19.9 16.1 36 36 36M400 692v120c0 19.9 16.1 36 36 36h152c19.9 0 36-16.1 36-36V692c0-19.9-16.1-36-36-36H436c-19.9 0-36 16.1-36 36"/></svg>`,
}
export const civicPooroutcomeOutline: {
  name: 'pooroutcomeOutline'
  data: string
} = {
  name: 'pooroutcomeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m829.5 455.7 37.3 37.3c15.8 15.8 15.8 41.3 0 56.9L540.5 876.4c-15.8 15.8-41.3 15.8-56.9 0L157.2 550.1c-15.8-15.8-15.8-41.3 0-56.9l37.3-37.3c16-16 42-15.6 57.6.7l192.6 202.2V176.1c0-22.3 18-40.3 40.3-40.3h53.7c22.3 0 40.3 18 40.3 40.3v482.6l192.8-202.4c15.7-16.4 41.7-16.7 57.7-.6"/></svg>`,
}
export const civicPositiveOutline: {
  name: 'positiveOutline'
  data: string
} = {
  name: 'positiveOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 63.8C264.4 63.8 63.8 264.4 63.8 512S264.4 960.2 512 960.2 960.2 759.6 960.2 512 759.6 63.8 512 63.8m260.2 498.8c0 11.9-9.8 21.7-21.7 21.7H584.3v166.3c0 11.9-9.8 21.7-21.7 21.7H461.4c-11.9 0-21.7-9.8-21.7-21.7V584.3H273.5c-11.9 0-21.7-9.8-21.7-21.7V461.4c0-11.9 9.8-21.7 21.7-21.7h166.3V273.5c0-11.9 9.8-21.7 21.7-21.7h101.2c11.9 0 21.7 9.8 21.7 21.7v166.3h166.3c11.9 0 21.7 9.8 21.7 21.7v101.1z"/></svg>`,
}
export const civicPredictiveOutline: {
  name: 'predictiveOutline'
  data: string
} = {
  name: 'predictiveOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M942.7 489.9c-183.3-357.6-678.1-357.7-861.4 0-7 13.9-7 30.3 0 44.2 183.3 357.6 678.1 357.7 861.4 0 7-13.9 7-30.3 0-44.2M512 730c-120.4 0-218-97.6-218-218s97.6-218 218-218 218 97.6 218 218c0 120.3-97.5 218.1-218 218m-38.3-357.6c49 66.5-34.7 150.2-101.3 101.3-21 77.3 24.7 156.9 101.9 177.9s156.9-24.7 177.9-101.9c29.7-109.3-72.1-208.3-178.5-177.3"/></svg>`,
}
export const civicPredisposingOutline: {
  name: 'predisposingOutline'
  data: string
} = {
  name: 'predisposingOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M943.1 793.8c28.3 49-7.2 110.2-63.7 110.2H144.6c-56.6 0-91.9-61.3-63.7-110.2l367.4-637c28.3-49 99.1-48.9 127.3 0zM512 662.1c-38.9 0-70.4 31.5-70.4 70.4s31.5 70.4 70.4 70.4 70.4-31.5 70.4-70.4-31.5-70.4-70.4-70.4m-66.9-253.2 11.4 208.2c.5 9.7 8.6 17.4 18.3 17.4h74.3c9.8 0 17.8-7.6 18.3-17.4l11.4-208.2c.6-10.5-7.8-19.4-18.3-19.4h-97.1c-10.5 0-18.8 8.9-18.3 19.4"/></svg>`,
}
export const civicPredispositionOutline: {
  name: 'predispositionOutline'
  data: string
} = {
  name: 'predispositionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M960 512c0 247.5-200.6 448-448 448S64 759.5 64 512C64 264.7 264.6 64 512 64s448 200.7 448 448m-448 90.3c-45.9 0-83.1 37.2-83.1 83.1s37.2 83.1 83.1 83.1 83.1-37.2 83.1-83.1-37.2-83.1-83.1-83.1m-78.9-298.7 13.4 245.7c.6 11.5 10.1 20.5 21.6 20.5h87.7c11.5 0 21-9 21.6-20.5l13.4-245.7c.7-12.4-9.2-22.9-21.6-22.9H454.7c-12.4.1-22.3 10.5-21.6 22.9"/></svg>`,
}
export const civicPrognosticOutline: {
  name: 'prognosticOutline'
  data: string
} = {
  name: 'prognosticOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M955.6 740.2 738.2 242.4c-7.7-17.7-24.6-29-43.1-29H543.3l3.8 36c.8 7.3-5 13.8-12.4 13.8h-45.4c-7.4 0-13.2-6.4-12.4-13.8l3.8-36H328.9c-18.6 0-35.4 11.3-43.1 29L68.4 740.2c-14.4 33 8.6 70.5 43.2 70.5h306.2l16-151.9c1.3-12.7 12-22.3 24.7-22.3h107c12.7 0 23.4 9.6 24.7 22.3l16 151.9h306.2c34.7 0 57.6-37.6 43.2-70.5M469.1 324c.7-6.3 6-11.1 12.4-11.1h61.1c6.4 0 11.7 4.8 12.4 11.1l7.2 67.8c1.2 11-7.5 20.6-18.6 20.6h-63.1c-11.1 0-19.7-9.6-18.6-20.6zM555 586.7h-86c-14.8 0-26.3-12.8-24.7-27.5l7.9-74.7c1.3-12.7 12-22.3 24.7-22.3h70.2c12.7 0 23.4 9.6 24.7 22.3l7.9 74.7c1.6 14.7-9.9 27.5-24.7 27.5"/></svg>`,
}
export const civicProtectivenessOutline: {
  name: 'protectivenessOutline'
  data: string
} = {
  name: 'protectivenessOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 758.1C373.9 758.1 262 648 262 512s111.9-246.1 250-246.1S762 376 762 512 650.1 758.1 512 758.1M512 64c-93.8.5-176.6 27.6-246.5 73.8-20 13.2-25.5 40.2-12.3 60.2 13.2 20.1 40.2 25.6 60.3 12.3C370.7 172.6 439 151 512.2 151c24 0 43.5-19.5 43.5-43.5 0-23.6-19-43.5-43.7-43.5M161.7 266.1c-27.6 0-38.9 23.8-37.8 22C78.2 367.2 60 453.8 64.7 537.3c1.4 25.4 21.5 42 43.4 42 25.1 0 44.9-21.1 43.5-46-4-69.3 11.5-139.5 47.7-202 16.9-29.1-4.4-65.2-37.6-65.2m-.3 404.5c-33.2 0-54.4 36.1-37.6 65.2C166.2 809.2 229.5 870.9 310 912c23.6 12.1 49.2 1.9 59.6-18.8 10.8-21.5 2.1-47.6-19.4-58.4-31.4-15.8-60.3-36-85.9-60.2-70.8-66.7-60.4-104-102.9-104m573.1 135.8c-8.2 0-16.5 2.3-23.9 7.2C651.7 852.4 583 873 512 873c-24.6 0-43.7 19.8-43.7 43.5 0 24 19.4 43.5 43.4 43.5 85.6.1 171.6-24.2 246.8-73.8 35.9-23.7 19-79.8-24-79.8m137.9-315.8c4 69.3-11.5 139.5-47.7 202-16.9 29.1 4.5 65.3 37.6 65.3 27.2 0 40-17.8 63.2-73.2 44.2-105.8 33.6-202.6 34-194.2-3-65.7-90.4-56.2-87.1.1M693.3 106.8c-45.7 0-60.4 61.9-19.6 82.4 63.4 31.8 116.2 82 151 142.3 8.1 14 22.6 21.9 37.8 21.9 33.2 0 54.4-36.1 37.6-65.2C858 215 793.4 151.9 712.8 111.4c-6.3-3.2-12.9-4.6-19.5-4.6"/></svg>`,
}
export const civicRaregermlineOutline: {
  name: 'raregermlineOutline'
  data: string
} = {
  name: 'raregermlineOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 400.5c61.9 0 111.9 49.9 111.9 111.5s-50 111.5-111.9 111.5S400.1 573.6 400.1 512s50-111.5 111.9-111.5m-111.9-161c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.9 128 512 128s-111.9 49.9-111.9 111.5m0 545c0 61.6 50.1 111.5 111.9 111.5s111.9-49.9 111.9-111.5S573.9 673 512 673s-111.9 49.9-111.9 111.5"/></svg>`,
}
export const civicRating1Outline: {
  name: 'rating1Outline'
  data: string
} = {
  name: 'rating1Outline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M620.3 894.9H473.8V329.8L299 383.9v-119c319.4-113.9 298.9-109 321.3-109z"/></svg>`,
}
export const civicRating2Outline: {
  name: 'rating2Outline'
  data: string
} = {
  name: 'rating2Outline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M770.6 894.9H264.7V794.6c217.2-231.5 275-286.4 311.5-348.2 36.1-61.2 27-121.4-1.3-153.3-44.8-50.8-177.9-42.6-177.9 96H250c0-87.9 42.9-167.3 123.2-210.6 91.1-49.1 235.7-41.8 310.4 23.1 71.8 62.3 81 173.5 34.7 266.1-41.6 83.3-126.6 163.2-265.1 309.2h317.3v118z"/></svg>`,
}
export const civicRating3Outline: {
  name: 'rating3Outline'
  data: string
} = {
  name: 'rating3Outline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M413.7 460.9c80.3 0 128.4 5.6 160.7-27.8 35.3-36.6 36.9-109.1.3-143.3-51.2-47.8-172.1-27.4-172.1 58.2H256.1c0-209 298-252.5 425.2-145.2 90.9 76.7 100.7 246.4-45.6 313 158.7 56.8 154 245.5 51.9 329.8C554.2 955.9 247 919.2 247 692.6h146.5c0 123.8 219.5 131.3 219.5-6.4 0-73.5-40.5-110.3-121.6-110.3h-77.5v-115z"/></svg>`,
}
export const civicRating4Outline: {
  name: 'rating4Outline'
  data: string
} = {
  name: 'rating4Outline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M697.8 616.9h83.6v118h-83.6v160H551.4v-160H248.8l-6.6-92.2 307.7-485.8h148v460zm-309.6 0h163.2V356.6c-13.8 23.8.6.4-163.2 260.3"/></svg>`,
}
export const civicRating5Outline: {
  name: 'rating5Outline'
  data: string
} = {
  name: 'rating5Outline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m286.5 532.4 42.6-375.5h413.6v122H449.2l-18.2 159c117.6-63.1 336-33.5 336 220.3 0 339-490.3 310.9-499.2 31.6h145c11.1 112.6 136.5 120.5 180.9 61.5 33.6-44.6 40.3-149.1-4.1-197-41.7-45-128.8-42.6-172.3-6.1l-14.2 13.1z"/></svg>`,
}
export const civicReducedsensitivityOutline: {
  name: 'reducedsensitivityOutline'
  data: string
} = {
  name: 'reducedsensitivityOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M855.4 186.6c-97.6-82.1-248.4-69.7-341.8 25.3-93.4-95.1-244.2-107.6-341.8-25.3-127 106.9-108.4 281.2-17.9 373.5l296.2 301.8c35.3 36 92.2 35.6 127 .2l296.2-301.8c90.3-92.4 109.2-266.6-17.9-373.7m-39.9 316.6C490.2 834.7 516.2 813.3 507.9 805L211.7 503.2c-61.6-62.8-74.1-181.7 12.3-254.5 65.7-55.2 167-46.9 230.5 17.7l59.1 60.3 59.1-60.3c63.8-65 165.1-72.9 230.5-17.9 86.3 72.9 73.5 192.4 12.3 254.7"/></svg>`,
}
export const civicResistanceOutline: {
  name: 'resistanceOutline'
  data: string
} = {
  name: 'resistanceOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m235 213c118.2 118.2 126.5 298.9 37.4 425.7l-463-463C448.2 150.5 628.9 158.8 747 277M277 747c-118.2-118.2-126.5-298.9-37.4-425.7l463 463C575.8 873.5 395.1 865.2 277 747"/></svg>`,
}
export const civicSensitivityresponseOutline: {
  name: 'sensitivityresponseOutline'
  data: string
} = {
  name: 'sensitivityresponseOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M855.4 186.6c-97.6-82.1-248.4-69.7-341.8 25.3-93.4-95.1-244.2-107.6-341.8-25.3-127 106.9-108.4 281.2-17.9 373.5l296.2 301.8c16.9 17.2 39.5 26.8 63.5 26.8 24.1 0 46.6-9.5 63.5-26.7l296.2-301.8c90.3-92.3 109.2-266.5-17.9-373.6"/></svg>`,
}
export const civicSequentialOutline: {
  name: 'sequentialOutline'
  data: string
} = {
  name: 'sequentialOutline',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="128"/><path d="M320 512c0 70.7-57.3 128-128 128S64 582.7 64 512s57.3-128 128-128 128 57.3 128 128m512-60c33.1 0 60 26.9 60 60s-26.9 60-60 60-60-26.9-60-60 26.9-60 60-60m0-68c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128"/></svg>`,
}
export const civicSignificanceunknownOutline: {
  name: 'significanceunknownOutline'
  data: string
} = {
  name: 'significanceunknownOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512.6 167.7c-107.3 0-176.9 44-231.5 122.4-9.9 14.2-6.8 33.7 7 44.2l58 44c14 10.6 33.8 8.1 44.7-5.6 33.7-42.2 58.7-66.5 111.3-66.5 41.4 0 92.5 26.6 92.5 66.7 0 30.3-25 45.9-65.9 68.8C481.1 468.4 418 501.6 418 584.8V598c0 17.8 14.5 32.3 32.3 32.3h97.5c17.8 0 32.3-14.5 32.3-32.3v-7.8c0-57.6 168.5-60 168.5-216 0-117.4-121.8-206.5-236-206.5M499.2 670c-51.4 0-93.2 41.8-93.2 93.2s41.8 93.2 93.2 93.2 93.2-41.8 93.2-93.2-41.9-93.2-93.2-93.2"/></svg>`,
}
export const civicSomaticOutline: {
  name: 'somaticOutline'
  data: string
} = {
  name: 'somaticOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M623.5 512c0 61.9-49.9 111.9-111.5 111.9s-111.5-50-111.5-111.9S450.4 400.1 512 400.1s111.5 50 111.5 111.9m161-111.9c-61.6 0-111.5 50-111.5 111.9s49.9 111.9 111.5 111.9S896 573.9 896 512s-49.9-111.9-111.5-111.9m-545 0c-61.6 0-111.5 50-111.5 111.9s49.9 111.9 111.5 111.9S351 573.9 351 512s-49.9-111.9-111.5-111.9"/></svg>`,
}
export const civicSubstitutesOutline: {
  name: 'substitutesOutline'
  data: string
} = {
  name: 'substitutesOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M224 452c33.1 0 60 26.9 60 60s-26.9 60-60 60-60-26.9-60-60 26.9-60 60-60m0-68c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128m704 128c0 70.7-57.3 128-128 128s-128-57.3-128-128 57.3-128 128-128 128 57.3 128 128M548 762V262c0-19.9-16.1-36-36-36s-36 16.1-36 36v500c0 19.9 16.1 36 36 36s36-16.1 36-36"/></svg>`,
}
export const civicSupportsOutline: {
  name: 'supportsOutline'
  data: string
} = {
  name: 'supportsOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M899.4 527.4c57.1-96.7-12.8-203.1-108.1-203.1h-54.7c30.3-79 19.6-226.9-129.6-226.9-92.4 0-87.1 142.4-107.6 162.9-34.1 34.1-74.4 99.7-103.1 125.1H248c-26.5 0-48 21.5-48 48v360c0 26.5 21.5 48 48 48h96c22.3 0 41.1-15.3 46.5-35.9 66.8 1.5 112.6 59.9 266.7 59.9h33.3c115.7 0 168-59.1 169.4-143 20-27.6 30.4-64.7 26-100.5 14.8-27.7 20.5-60.5 13.5-94.5m-92.6 80.8c18.8 31.7 1.9 74.1-20.9 86.4 17.6 111.7-74.8 98.8-136.4 98.8-107.5 0-177-56.7-257.5-56.7V457.4h16.4c42.5 0 102-106.3 141.8-146.2 42.5-42.5 28.4-113.4 56.7-141.8 70.9 0 70.9 49.5 70.9 85.1 0 58.8-42.5 85.1-42.5 141.8h156c31.7 0 56.6 28.4 56.7 56.7s-19.2 56.7-33.4 56.7c20.2 21.9 24.6 67.9-7.8 98.5M332 745.4c0 19.9-16.1 36-36 36s-36-16.1-36-36 16.1-36 36-36 36 16.1 36 36"/></svg>`,
}
export const civicUnalteredfunctionOutline: {
  name: 'unalteredfunctionOutline'
  data: string
} = {
  name: 'unalteredfunctionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M725.4 360.7v80.6H298.6v-80.6c0-37.4-45.2-56.2-71.7-29.7L76.3 481.6c-16.4 16.4-16.4 43 0 59.4l150.6 150.6c26.5 26.5 71.7 7.7 71.7-29.7v-80.6h426.8v80.6c0 37.4 45.2 56.2 71.7 29.7L947.7 541c16.4-16.4 16.4-43 0-59.4L797.1 331c-26.5-26.4-71.7-7.7-71.7 29.7"/></svg>`,
}
export const civicUncertainsignificanceOutline: {
  name: 'uncertainsignificanceOutline'
  data: string
} = {
  name: 'uncertainsignificanceOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.7 64 512c0 247.5 200.6 448 448 448s448-200.5 448-448c0-247.3-200.6-448-448-448m0 809.3c-199.7 0-361.3-161.6-361.3-361.3 0-199.6 161.6-361.3 361.3-361.3 199.6 0 361.3 161.6 361.3 361.3S711.7 873.3 512 873.3m193.7-461c0 121.1-130.8 123-130.8 167.8v11.4c0 12-9.7 21.7-21.7 21.7h-82.5c-12 0-21.7-9.7-21.7-21.7v-15.6c0-64.6 49-90.4 85.9-111.1 31.7-17.8 51.2-29.9 51.2-53.4 0-31.2-39.7-51.8-71.9-51.8-41.9 0-61.2 19.8-88.4 54.1-7.3 9.2-20.7 11-30.1 3.8l-50.3-38.1c-9.2-7-11.3-20-4.8-29.6 42.7-62.7 97-97.9 181.7-97.9 88.8 0 183.4 69.2 183.4 160.4m-117.8 302c0 41.8-34 75.9-75.9 75.9s-75.9-34-75.9-75.9c0-41.8 34-75.9 75.9-75.9s75.9 34.1 75.9 75.9"/></svg>`,
}
export const civicUnknownOutline: {
  name: 'unknownOutline'
  data: string
} = {
  name: 'unknownOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M960 512c0 247.5-200.6 448-448 448S64 759.5 64 512C64 264.7 264.6 64 512 64s448 200.7 448 448M524 212.1c-98.4 0-161.2 41.5-210.5 115.2-6.4 9.5-4.3 22.4 4.9 29.4l62.7 47.5c9.4 7.1 22.8 5.4 30.1-3.8 32.3-40.9 54.4-64.7 103.5-64.7 36.9 0 82.6 23.8 82.6 59.5 0 27.1-22.3 40.9-58.8 61.4-42.5 23.8-98.7 53.5-98.7 127.6v7.2c0 12 9.7 21.7 21.7 21.7h101.2c12 0 21.7-9.7 21.7-21.7V589c0-51.4 150.3-53.6 150.3-192.7-.2-104.7-108.9-184.2-210.7-184.2m-12 448c-45.8 0-83.1 37.3-83.1 83.1s37.3 83.1 83.1 83.1 83.1-37.3 83.1-83.1-37.3-83.1-83.1-83.1"/></svg>`,
}
export const civicAdminFullcolor: {
  name: 'adminFullcolor'
  data: string
} = {
  name: 'adminFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6F1F6" d="M895.2 870.4c-10.2-154.4-111-279-238.5-331.1C724.2 492.9 768 415.9 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 86.8 43 165.2 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.7 0 725.9 3.2 736-7.6 4.5-4.9 6.8-11.4 6.4-18"/><path fill="#58A0C4" d="M895.2 870.4c-10.2-154.4-111-279-238.5-331.1C724.2 492.9 768 415.9 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 86.8 43 165.2 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.7 0 725.9 3.2 736-7.6 4.5-4.9 6.8-11.4 6.4-18M328 328V192h368v136c0 164.8-199.4 244.9-314.1 130.1C347.1 423.4 328 377.2 328 328"/></svg>`,
}
export const civicAssertionFullcolor: {
  name: 'assertionFullcolor'
  data: string
} = {
  name: 'assertionFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#EAE3F4" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#7243B5" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128m0 420c-161.4 0-292-130.6-292-292s130.6-292 292-292 292 130.6 292 292-130.6 292-292 292m0-512c-121.6 0-220 98.4-220 220s98.4 220 220 220 220-98.4 220-220-98.4-220-220-220"/></svg>`,
}
export const civicClinicaltrialFullcolor: {
  name: 'clinicaltrialFullcolor'
  data: string
} = {
  name: 'clinicaltrialFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#F3E1EF" d="M512 183.4c181.5 0 328.6 146.9 328.6 328.6 0 181.5-146.9 328.6-328.6 328.6-180.6 0-328.6-146.1-328.6-328.6 0-181.5 146.9-328.6 328.6-328.6"/><path fill="#AC3996" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m36 745.5V301.4c0-19.9-16.1-36-36-36s-36 16.1-36 36v508.2c0 19.9 16.1 36 36 36 19.9-.1 36-16.2 36-36.1M290.5 664.2v-39c0-19.9-16.1-36-36-36s-36 16.1-36 36v39c0 19.9 16.1 36 36 36s36-16.1 36-36m128.8 114.2V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v329.3c0 19.9 16.1 36 36 36s36-16.2 36-36.1m258.8-.5V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v328.7c0 19.9 16.1 36 36 36s36-16.1 36-36m130.1-119.1v-31.9c0-19.9-16.1-36-36-36s-36 16.1-36 36v31.9c0 19.9 16.1 36 36 36s36-16.1 36-36"/></svg>`,
}
export const civicCommentFullcolor: {
  name: 'commentFullcolor'
  data: string
} = {
  name: 'commentFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E3F9FD" d="M200 128c-39.8 0-72 32.2-72 72v432c0 39.8 32.2 72 72 72h312v148c0 34.6 44.1 49.1 64.8 21.6L704 704h120c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72z"/><path fill="#44D8EF" d="M824 200c-.1 0-.1 432 0 432H668c-7.9 10.5-73 97.4-84 112V632H200c-.1 0 0 8.4 0-432 0-.1-13.7 0 624 0m-624-72c-39.8 0-72 32.2-72 72v432c0 39.8 32.2 72 72 72h312v148c0 34.6 44.1 49.1 64.8 21.6L704 704h120c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72zm184 288c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64 64 28.7 64 64m128-64c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64m192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64"/></svg>`,
}
export const civicCoordinatesystemFullcolor: {
  name: 'coordinatesystemFullcolor'
  data: string
} = {
  name: 'coordinatesystemFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#DDF4F2" d="M512 924c-55.6 0-109.6-10.9-160.4-32.4-49.1-20.7-93.1-50.5-131-88.3-37.8-37.8-67.6-81.9-88.3-131C110.9 621.6 100 567.6 100 512s10.9-109.6 32.4-160.4c20.7-49.1 50.5-93.1 88.3-131 37.8-37.8 81.9-67.6 131-88.3C402.4 110.9 456.4 100 512 100s109.6 10.9 160.4 32.4c49.1 20.7 93.1 50.5 131 88.3 37.8 37.8 67.6 81.9 88.3 131C913.1 402.4 924 456.4 924 512s-10.9 109.6-32.4 160.4c-20.7 49.1-50.5 93.1-88.3 131s-81.9 67.6-131 88.3C621.6 913.1 567.6 924 512 924"/><path fill="#1DB8A9" d="M512 136c50.8 0 100 9.9 146.3 29.5 44.8 18.9 85 46.1 119.5 80.6 34.6 34.6 61.7 74.8 80.6 119.5C878.1 412 888 461.2 888 512s-9.9 100-29.5 146.3c-18.9 44.8-46.1 85-80.6 119.5-34.6 34.6-74.8 61.7-119.5 80.6C612 878.1 562.8 888 512 888s-100-9.9-146.3-29.5c-44.8-18.9-85-46.1-119.5-80.6-34.6-34.6-61.7-74.8-80.6-119.5C145.9 612 136 562.8 136 512s9.9-100 29.5-146.3c18.9-44.8 46.1-85 80.6-119.5 34.6-34.6 74.8-61.7 119.5-80.6C412 145.9 461.2 136 512 136m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#1DB8A9" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m375.9 440.8-154.7 55.4-81-225.9L807 278.8c49.3 62.2 79.3 140.6 80.9 226m-222.5 79.7-225.9 81-81-225.9 225.9-81zm86.2-362.3L628 266.5l-44.3-123.7c60.2 11.6 118.4 38.3 167.9 79.4m-246.8-86.1 55.4 154.7-225.9 81L278.8 217c62.2-49.3 140.6-79.3 226-80.9M222.2 272.4 266.5 396l-123.7 44.3c11.6-60.2 38.3-118.4 79.4-167.9m-86.1 246.8 154.7-55.4 81 225.9L217 745.2c-49.3-62.2-79.3-140.6-80.9-226m136.3 282.6L396 757.5l44.3 123.7c-60.2-11.6-118.4-38.3-167.9-79.4m246.8 86.1-55.4-154.7 225.9-81L745.2 807c-62.2 49.3-140.6 79.3-226 80.9m282.6-136.3L757.5 628l123.7-44.3c-11.6 60.2-38.3 118.4-79.4 167.9"/></svg>`,
}
export const civicCuratorFullcolor: {
  name: 'curatorFullcolor'
  data: string
} = {
  name: 'curatorFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#F1F9FD" d="M512 548c-121.6 0-220-98.4-220-220s98.4-220 220-220 220 98.4 220 220-98.4 220-220 220m348 348c0-192.4-155.7-348-348-348-192.4 0-348 155.7-348 348"/><path fill="#A0D8F5" d="M655.8 539.9C862.9 399.3 764.6 72 512 72c-253.1 0-350.2 327.6-143.9 467.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.6 150.1-312 312-312 178.6 0 312 144.8 312 312 0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M328 328c0-101.8 82.2-184 184-184s184 82.2 184 184c0 98.5-77 178.7-174.2 183.7-6.5-.2-13.1-.2-19.7 0C404.9 506.6 328 426.5 328 328"/></svg>`,
}
export const civicDiseaseFullcolor: {
  name: 'diseaseFullcolor'
  data: string
} = {
  name: 'diseaseFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#DFE8F4"/><path fill="#2A63B6" d="M422.7 512c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96m537.3 0c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-358.7 0c0 53 43 96 96 96s96-43 96-96-43-96-96-96-96 43-96 96M512 888V136c-207.7 0-376 168.3-376 376s168.3 376 376 376"/><circle cx="512" cy="512" r="448" fill="#FBE0EA"/><path fill="#E62F76" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-79.1 225.9c-79 0-143.1 64.1-143.1 143.1s64.1 143 143.1 143S576 511.9 576 432.9s-64.1-143-143.1-143"/></svg>`,
}
export const civicEditorFullcolor: {
  name: 'editorFullcolor'
  data: string
} = {
  name: 'editorFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6F1F6" d="M164 896c0-192.3 155.6-348 348-348 192.3 0 348 155.6 348 348M732 328V108H292v220c0 121.6 98.4 220 220 220s220-98.4 220-220"/><path fill="#58A0C4" d="M655.8 539.9C723.6 493.9 768 416.2 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 88.2 44.4 165.8 112.1 211.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.7 147.1-306.4 303.7-312.1 6.5.2 11.8.2 19.4-.1C685 588 824 723.4 824 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M523 511.8c-8.1-.2-16.3-.2-24.5.1-92-6-170.5-84.2-170.5-183.9V192h368v136c0 105.3-83 177.5-173 183.8"/></svg>`,
}
export const civicEventFullcolor: {
  name: 'eventFullcolor'
  data: string
} = {
  name: 'eventFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#FFF8CC"/><path fill="#FFDB00" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m147.8 386.8L693 331l-119.8 33.2L512 256l-61.2 108.2L331 331l33.2 119.8L256 512l108.2 61.2L331 693l119.8-33.2L512 768l61.2-108.2L693 693l-33.2-119.8L768 512z"/></svg>`,
}
export const civicEvidenceFullcolor: {
  name: 'evidenceFullcolor'
  data: string
} = {
  name: 'evidenceFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#FEEEE1"/><path fill="#F68F37" d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicEvidenceitemFullcolor: {
  name: 'evidenceitemFullcolor'
  data: string
} = {
  name: 'evidenceitemFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#FEEEE1"/><path fill="#F68F37" d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicFeatureFullcolor: {
  name: 'featureFullcolor'
  data: string
} = {
  name: 'featureFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6F7FD"/><path fill="#07AFF0" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 246.1C473.6 18.6 857 165.3 886.3 476H137.7c8-84.6 44.8-166.3 108.4-229.9"/></svg>`,
}
export const civicFlagFullcolor: {
  name: 'flagFullcolor'
  data: string
} = {
  name: 'flagFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#FBE3E6"/><path fill="#E24759" d="M774.9 553.6c7.4 6.2 4.9 18.2-4.5 20.8L433.6 666c-6.4 1.7-13-2-14.7-8.4L341.2 372c-1.7-6.4 2-13 8.4-14.7C709 259.5 690.9 261 698.4 269c3 3.3 4 8 2.5 12.2-58.6 162.9-61 159.8-51.8 167.5zM960 512c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-72 0c0-207.7-168.3-376-376-376S136 304.3 136 512c0 157.7 96.9 292.6 234.5 348.5L241.6 386.6c-5.2-19.2 6.1-39 25.3-44.2s39 6.1 44.2 25.3l140.2 515.5c19.8 3.2 40.1 4.9 60.8 4.9C719.7 888 888 719.7 888 512"/></svg>`,
}
export const civicMolecularprofileFullcolor: {
  name: 'molecularprofileFullcolor'
  data: string
} = {
  name: 'molecularprofileFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E0F4E6"/><path fill="#33B358" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-17.4 72.4V494H136.4c9.1-193.6 164.7-348.9 358.2-357.6m36 751.2V530h357c-9 193.1-164 348.3-357 357.6"/></svg>`,
}
export const civicOrganizationFullcolor: {
  name: 'organizationFullcolor'
  data: string
} = {
  name: 'organizationFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6F1F6" d="M256.4 325.1c0-95.8 77.5-173.4 173.4-173.4 44 0 84.1 16.3 114.6 43.2C410.5 220.5 327 347.5 340.2 473.6c-50.3-30.3-83.8-85.5-83.8-148.5m134.9 275.6c-21.5-28.1-36-58.5-44.2-89.6-111.1 35-191.6 138.8-191.6 261.6h103.1c25.5-71.3 72.9-130.7 132.7-172m376.3-155.1c0-95.8-77.6-173.4-173.4-173.4s-173.4 77.6-173.4 173.4S498.4 619 594.2 619c95.9 0 173.4-77.5 173.4-173.4M320 893.3C320 741.7 442.7 619 594.3 619s274.3 122.7 274.3 274.3z"/><path fill="#58A0C4" d="M187.5 772.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 66 0 119.4 28.5 155.2 70.7-28.4 1-55 6.3-79.4 15.2-21.9-13.9-47.9-21.9-75.8-21.9-78.2 0-141.4 63.2-141.4 141.4 0 43.7 19.7 82.7 50.8 108.6-1.9 36.1 3.8 72.9 18.2 108.2-93.8 29.8-169.8 114.9-169.8 230.8m713 120.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-64.8-25.2-125.6-70.9-171.3C613.6 570 352 678 352 893.3c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 197.1 0 281.4 253.6 121.6 371 105.9 46.2 184.7 153.5 184.7 282M586.3 586.8c5.9-.2 11.9-.3 17.8-.1 73.6-5.1 131.5-66.1 131.5-141 0-78.2-63.2-141.4-141.4-141.4s-141.4 63.2-141.4 141.4c.1 75.5 59 137 133.5 141.1"/></svg>`,
}
export const civicPhenotypeFullcolor: {
  name: 'phenotypeFullcolor'
  data: string
} = {
  name: 'phenotypeFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#DFE8F4"/><path fill="#2A63B6" d="M422.7 512c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96m537.3 0c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-358.7 0c0 53 43 96 96 96s96-43 96-96-43-96-96-96-96 43-96 96M512 888V136c-207.7 0-376 168.3-376 376s168.3 376 376 376"/></svg>`,
}
export const civicQueueFullcolor: {
  name: 'queueFullcolor'
  data: string
} = {
  name: 'queueFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E2EBF0" d="M674.7 791.2C656.4 864.1 590.5 918 512 918s-144.4-54-162.7-126.8c44.4 36.2 101 57.9 162.7 57.9s118.3-21.7 162.7-57.9M512 690.2c-61.7 0-118.3-21.7-162.7-57.9 18.3 72.9 84.2 126.8 162.7 126.8s144.4-54 162.7-126.8c-44.4 36.2-101 57.9-162.7 57.9m0-158.9c-61.7 0-118.3-21.7-162.7-57.9 18.3 72.9 84.2 126.8 162.7 126.8s144.4-54 162.7-126.8c-44.4 36.2-101 57.9-162.7 57.9m167.7-257.6c0-92.6-75.1-167.7-167.7-167.7s-167.7 75-167.7 167.7S419.4 441.4 512 441.4s167.7-75.1 167.7-167.7"/><path fill="#3D7B99" d="M312.3 913.1C165.1 839.7 64 687.7 64 512s101.1-327.7 248.3-401.1c-28.6 35.1-48.2 77.8-55.1 124.6C182.7 304.2 136 402.6 136 512s46.6 207.8 121.1 276.5c7 46.8 26.6 89.6 55.2 124.6m454.6-677.6C841.4 304.2 888 402.6 888 512s-46.7 207.8-121.2 276.5c-7 46.8-26.5 89.6-55.1 124.6C858.9 839.7 960 687.7 960 512S858.9 184.3 711.7 110.9c28.6 35 48.2 77.8 55.2 124.6m-45.4 506C726.4 861.1 631 960 512 960c-119.1 0-214.4-99.1-209.5-218.5 23.6 32.9 54.7 59.9 90.8 78.7 53.4 90.6 184.2 90.1 237.3 0 36.2-18.8 67.3-45.8 90.9-78.7m-90.8-80.2c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-5 119.4 90.2 218.5 209.4 218.5 119 0 214.4-98.9 209.5-218.5-23.6 32.9-54.7 60-90.8 78.7m0-158.9c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-4.9 119.4 90.3 218.5 209.5 218.5 119 0 214.4-98.9 209.5-218.5-23.7 32.9-54.8 60-90.9 78.7M374.3 273.7c0 76.1 61.6 137.7 137.7 137.7s137.7-61.6 137.7-137.7S588.1 136 512 136s-137.7 61.6-137.7 137.7m-72 0C302.3 157.9 396.2 64 512 64s209.7 93.9 209.7 209.7S627.8 483.3 512 483.3s-209.7-93.8-209.7-209.6"/></svg>`,
}
export const civicRevisionFullcolor: {
  name: 'revisionFullcolor'
  data: string
} = {
  name: 'revisionFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#FDE8E1" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#F0673A" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m281.4 341.9c14.1-14.1 14.1-36.9 0-50.9L669 230.6c-14.1-14.1-36.9-14.1-50.9 0L291.7 556.9l-18.7 181c-.4 3.6.9 7.2 3.5 9.7 2.6 2.6 6.1 3.8 9.7 3.5l180.9-18.7zm-76.3-25.4-39.6 39.6-73.5-73.5 39.6-39.6zM352.2 671.8l8.5-82L553 397.4l73.5 73.5-192.3 192.4z"/></svg>`,
}
export const civicSourceFullcolor: {
  name: 'sourceFullcolor'
  data: string
} = {
  name: 'sourceFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#FEF5E3" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#F9BA45" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128"/></svg>`,
}
export const civicTherapyFullcolor: {
  name: 'therapyFullcolor'
  data: string
} = {
  name: 'therapyFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><ellipse cx="512" cy="512" fill="#F3E1EF" rx="416" ry="412" transform="rotate(-45.001 511.997 512.008)"/><path fill="#AC3996" d="m353.2 404.1-158-158c-14.1-14.1-14.1-36.9 0-50.9 14.1-14.1 36.9-14.1 50.9 0l158 158c-19.7 13.4-37.1 30.6-50.9 50.9m327.4 523.1c228.3-92.6 339.9-353.7 246.6-583.8-103.8-256-411.9-356.2-645.7-215.7-17 10.2-22.6 32.4-12.3 49.4 10.2 17 32.4 22.6 49.4 12.3 70.6-42.4 154.8-60.5 237.1-50.9 308.2 35.8 446 415.5 222.2 639.3s-602.4 86-639.2-220.8c-9.8-81.9 7.3-165 49.3-236.1 10.1-17.1 4.4-39.2-12.7-49.3s-39.2-4.4-49.3 12.7C77.2 367 55.2 465.6 67.2 565.6c35.1 293.1 340.3 472.3 613.4 361.6m-32.8-551c-66.3-66.3-169-74-243.7-23.1l133.4 133.4c22.7 22.7 6.3 61.5-25.5 61.5-20 0-12.1 2.8-158.8-143.9-50.9 74.7-43.2 177.4 23.1 243.7 75 75 196.5 75 271.5 0s74.9-196.6 0-271.6"/></svg>`,
}
export const civicUserFullcolor: {
  name: 'userFullcolor'
  data: string
} = {
  name: 'userFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#A0D8F5" d="M895.2 870.4c-6.2-93.3-45.8-180.2-111.6-246-38.6-38.6-81.7-66.7-126.9-85.1C724 493.2 768 415.8 768 328c0-141.6-114.4-256-256-256S256 186.4 256 328c0 88.6 44.8 166.6 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.9 0 724.8 4.3 736-7.6 4.5-4.9 6.8-11.4 6.4-18"/></svg>`,
}
export const civicVariant: {
  name: 'variant'
  data: string
} = {
  name: 'variant',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E0F4E6"/><path fill="#33B358" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 777.9C18.7 550.4 165.3 167 476 137.7v748.6c-84.6-8-166.3-44.8-229.9-108.4"/></svg>`,
}
export const civicVariantgroupFullcolor: {
  name: 'variantgroupFullcolor'
  data: string
} = {
  name: 'variantgroupFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E0F4E6"/><path fill="#33B358" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M256 787.4V236.6c36-33.5 78.9-60.5 128-78.3v707.3c-46.1-16.6-89.6-42.5-128-78.2m320 95.2V141.4c44.3 7.6 87.7 23.2 128 47.2v646.7c-38.8 23.2-82 39.4-128 47.3"/></svg>`,
}
export const civicVarianttypeFullcolor: {
  name: 'varianttypeFullcolor'
  data: string
} = {
  name: 'varianttypeFullcolor',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E0F4E6"/><path fill="#33B358" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m72.6 318.7c1.9 3.1 101.9 167 104.9 172 51.7-6.2 97.5 34 97.5 86.4 0 48.1-39 87-87 87-70.2 0-110.9-78.8-72-135.9-2.8-4.5-103.4-169.6-104.5-171.3-52.4 6.9-98.5-33.8-98.5-86.2 0-48.1 39-87 87-87 69.7 0 110.5 77.8 72.6 135M136 512c0-207.7 168.3-376 376-376v73.7c-109.3 0-164.6 129.9-92.5 209.1l-84.3 136c-52.1-6.7-98.2 33.8-98.2 86.3 0 48.1 39 87 87 87 70 0 110.6-78.3 72.3-135.4l84.9-136.9c9.8 2.5 20.2 3.8 30.8 3.8V888c-207.7 0-376-168.3-376-376"/></svg>`,
}
export const civicOrcid: {
  name: 'orcid'
  data: string
} = {
  name: 'orcid',
  data: `<svg viewBox="0 0 896 896"><path d="M647.4 462.7c0 41.3-25 124.2-134.3 124.2h-76.7V338.5h74.2c93.9 0 136.8 56.9 136.8 124.2M848.6 448c0 221.3-179.3 400.6-400.6 400.6S47.4 669.3 47.4 448 226.7 47.4 448 47.4 848.6 226.7 848.6 448M317.5 295h-48.2v335.2h48.2V295m7.5-69.8c0-17.2-14.1-31.6-31.6-31.6s-31.6 14.1-31.6 31.6c0 17.2 14.1 31.6 31.6 31.6s31.6-14.4 31.6-31.6m371.8 237.5c0-79.2-54.5-167.7-178.4-167.7H388.2v335.5H519c110.5 0 177.8-81.7 177.8-167.8"/></svg>`,
}
export const civicAdminOutline: {
  name: 'adminOutline'
  data: string
} = {
  name: 'adminOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M895.2 870.4c-10.2-154.4-111-279-238.5-331.1C724.2 492.9 768 415.9 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 86.8 43 165.2 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.7 0 725.9 3.2 736-7.6 4.5-4.9 6.8-11.4 6.4-18M328 328V192h368v136c0 164.8-199.4 244.9-314.1 130.1C347.1 423.4 328 377.2 328 328"/></svg>`,
}
export const civicAssertionOutline: {
  name: 'assertionOutline'
  data: string
} = {
  name: 'assertionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128m0 420c-161.4 0-292-130.6-292-292s130.6-292 292-292 292 130.6 292 292-130.6 292-292 292m0-512c-121.6 0-220 98.4-220 220s98.4 220 220 220 220-98.4 220-220-98.4-220-220-220"/></svg>`,
}
export const civicClinicaltrialOutline: {
  name: 'clinicaltrialOutline'
  data: string
} = {
  name: 'clinicaltrialOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m36 745.5V301.4c0-19.9-16.1-36-36-36s-36 16.1-36 36v508.2c0 19.9 16.1 36 36 36 19.9-.1 36-16.2 36-36.1M290.5 664.2v-39c0-19.9-16.1-36-36-36s-36 16.1-36 36v39c0 19.9 16.1 36 36 36s36-16.1 36-36m128.8 114.2V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v329.3c0 19.9 16.1 36 36 36s36-16.2 36-36.1m258.8-.5V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v328.7c0 19.9 16.1 36 36 36s36-16.1 36-36m130.1-119.1v-31.9c0-19.9-16.1-36-36-36s-36 16.1-36 36v31.9c0 19.9 16.1 36 36 36s36-16.1 36-36"/></svg>`,
}
export const civicCommentOutline: {
  name: 'commentOutline'
  data: string
} = {
  name: 'commentOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M824 200c-.1 0-.1 432 0 432H668c-7.9 10.5-73 97.4-84 112V632H200c-.1 0 0 8.4 0-432 0-.1-13.7 0 624 0m-624-72c-39.8 0-72 32.2-72 72v432c0 39.8 32.2 72 72 72h312v148c0 34.6 44.1 49.1 64.8 21.6L704 704h120c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72zm184 288c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64 64 28.7 64 64m128-64c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64m192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64"/></svg>`,
}
export const civicCoordinatesystemOutline: {
  name: 'coordinatesystemOutline'
  data: string
} = {
  name: 'coordinatesystemOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m375.9 440.8-154.7 55.4-81-225.9L807 278.8c49.3 62.2 79.3 140.6 80.9 226m-222.5 79.7-225.9 81-81-225.9 225.9-81zm86.2-362.3L628 266.5l-44.3-123.7c60.2 11.6 118.4 38.3 167.9 79.4m-246.8-86.1 55.4 154.7-225.9 81L278.8 217c62.2-49.3 140.6-79.3 226-80.9M222.2 272.4 266.5 396l-123.7 44.3c11.6-60.2 38.3-118.4 79.4-167.9m-86.1 246.8 154.7-55.4 81 225.9L217 745.2c-49.3-62.2-79.3-140.6-80.9-226m136.3 282.6L396 757.5l44.3 123.7c-60.2-11.6-118.4-38.3-167.9-79.4m246.8 86.1-55.4-154.7 225.9-81L745.2 807c-62.2 49.3-140.6 79.3-226 80.9m282.6-136.3L757.5 628l123.7-44.3c-11.6 60.2-38.3 118.4-79.4 167.9"/></svg>`,
}
export const civicCuratorOutline: {
  name: 'curatorOutline'
  data: string
} = {
  name: 'curatorOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M655.8 539.9C862.9 399.3 764.6 72 512 72c-253.1 0-350.2 327.6-143.9 467.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.6 150.1-312 312-312 178.6 0 312 144.8 312 312 0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M328 328c0-101.8 82.2-184 184-184s184 82.2 184 184c0 98.5-77 178.7-174.2 183.7-6.5-.2-13.1-.2-19.7 0C404.9 506.6 328 426.5 328 328"/></svg>`,
}
export const civicDiseaseOutline: {
  name: 'diseaseOutline'
  data: string
} = {
  name: 'diseaseOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-79.1 225.9c-79 0-143.1 64.1-143.1 143.1s64.1 143 143.1 143S576 511.9 576 432.9s-64.1-143-143.1-143"/></svg>`,
}
export const civicEditorOutline: {
  name: 'editorOutline'
  data: string
} = {
  name: 'editorOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M655.8 539.9C723.6 493.9 768 416.2 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 88.2 44.4 165.8 112.1 211.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.7 147.1-306.4 303.7-312.1 6.5.2 11.8.2 19.4-.1C685 588 824 723.4 824 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M523 511.8c-8.1-.2-16.3-.2-24.5.1-92-6-170.5-84.2-170.5-183.9V192h368v136c0 105.3-83 177.5-173 183.8"/></svg>`,
}
export const civicEventOutline: {
  name: 'eventOutline'
  data: string
} = {
  name: 'eventOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m147.8 386.8L693 331l-119.8 33.2L512 256l-61.2 108.2L331 331l33.2 119.8L256 512l108.2 61.2L331 693l119.8-33.2L512 768l61.2-108.2L693 693l-33.2-119.8L768 512z"/></svg>`,
}
export const civicEvidenceOutline: {
  name: 'evidenceOutline'
  data: string
} = {
  name: 'evidenceOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicEvidenceitemOutline: {
  name: 'evidenceitemOutline'
  data: string
} = {
  name: 'evidenceitemOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicFeatureOutline: {
  name: 'featureOutline'
  data: string
} = {
  name: 'featureOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 246.1C473.6 18.6 857 165.3 886.3 476H137.7c8-84.6 44.8-166.3 108.4-229.9"/></svg>`,
}
export const civicFlagOutline: {
  name: 'flagOutline'
  data: string
} = {
  name: 'flagOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M774.9 553.6c7.4 6.2 4.9 18.2-4.5 20.8L433.6 666c-6.4 1.7-13-2-14.7-8.4L341.2 372c-1.7-6.4 2-13 8.4-14.7C709 259.5 690.9 261 698.4 269c3 3.3 4 8 2.5 12.2-58.6 162.9-61 159.8-51.8 167.5zM960 512c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-72 0c0-207.7-168.3-376-376-376S136 304.3 136 512c0 157.7 96.9 292.6 234.5 348.5L241.6 386.6c-5.2-19.2 6.1-39 25.3-44.2s39 6.1 44.2 25.3l140.2 515.5c19.8 3.2 40.1 4.9 60.8 4.9C719.7 888 888 719.7 888 512"/></svg>`,
}
export const civicMolecularprofileOutline: {
  name: 'molecularprofileOutline'
  data: string
} = {
  name: 'molecularprofileOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-17.4 72.4V494H136.4c9.1-193.6 164.7-348.9 358.2-357.6m36 751.2V530h357c-9 193.1-164 348.3-357 357.6"/></svg>`,
}
export const civicOrganizationOutline: {
  name: 'organizationOutline'
  data: string
} = {
  name: 'organizationOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M187.5 772.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 66 0 119.4 28.5 155.2 70.8-27.7 1-54.2 6.4-78.9 15.5-22-14.1-48.1-22.2-76.3-22.2-132.4 0-191.3 166-90.6 250-1.7 37.4 4.6 74 18.4 108.1-93.9 29.7-170 114.8-170 230.8m713 120.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-64.8-25.2-125.6-70.9-171.3C613.6 570 352 678 352 893.3c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 197.1 0 281.4 253.6 121.6 371 105.9 46.2 184.7 153.5 184.7 282M586.3 586.8c5.9-.2 11.9-.3 17.8-.1 73.6-5.1 131.5-66.1 131.5-141 0-78.2-63.2-141.4-141.4-141.4s-141.4 63.2-141.4 141.4c.1 75.5 59 137 133.5 141.1"/></svg>`,
}
export const civicPhenotypeOutline: {
  name: 'phenotypeOutline'
  data: string
} = {
  name: 'phenotypeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M422.7 512c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96m537.3 0c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-358.7 0c0 53 43 96 96 96s96-43 96-96-43-96-96-96-96 43-96 96M512 888V136c-207.7 0-376 168.3-376 376s168.3 376 376 376"/></svg>`,
}
export const civicQueueOutline: {
  name: 'queueOutline'
  data: string
} = {
  name: 'queueOutline',
  data: `<svg viewBox="0 0 1024 1024"><path fill="none" d="M512 409.7v204.7"/><path d="M312.3 913.1C165.1 839.7 64 687.7 64 512s101.1-327.7 248.3-401.1c-28.6 35.1-48.2 77.8-55.1 124.6C182.7 304.2 136 402.6 136 512s46.6 207.8 121.1 276.5c7 46.8 26.6 89.6 55.2 124.6m454.6-677.6C841.4 304.2 888 402.6 888 512s-46.7 207.8-121.2 276.5c-7 46.8-26.5 89.6-55.1 124.6C858.9 839.7 960 687.7 960 512S858.9 184.3 711.7 110.9c28.6 35 48.2 77.8 55.2 124.6m-45.4 506C726.4 861.1 631 960 512 960c-119.1 0-214.4-99.1-209.5-218.5 23.6 32.9 54.7 59.9 90.8 78.7 53.4 90.6 184.2 90.1 237.3 0 36.2-18.8 67.3-45.8 90.9-78.7m-90.8-80.2c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-5 119.4 90.2 218.5 209.4 218.5 119 0 214.4-98.9 209.5-218.5-23.6 32.9-54.7 60-90.8 78.7m0-158.9c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-4.9 119.4 90.3 218.5 209.5 218.5 119 0 214.4-98.9 209.5-218.5-23.7 32.9-54.8 60-90.9 78.7M374.3 273.7c0 76.1 61.6 137.7 137.7 137.7s137.7-61.6 137.7-137.7S588.1 136 512 136s-137.7 61.6-137.7 137.7m-72 0C302.3 157.9 396.2 64 512 64s209.7 93.9 209.7 209.7S627.8 483.3 512 483.3s-209.7-93.8-209.7-209.6"/></svg>`,
}
export const civicRevisionOutline: {
  name: 'revisionOutline'
  data: string
} = {
  name: 'revisionOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m281.4 341.9c14.1-14.1 14.1-36.9 0-50.9L669 230.6c-14.1-14.1-36.9-14.1-50.9 0L291.7 556.9l-18.7 181c-.4 3.6.9 7.2 3.5 9.7 2.6 2.6 6.1 3.8 9.7 3.5l180.9-18.7zm-76.3-25.4-39.6 39.6-73.5-73.5 39.6-39.6zM352.2 671.8l8.5-82L553 397.4l73.5 73.5-192.3 192.4z"/></svg>`,
}
export const civicSourceOutline: {
  name: 'sourceOutline'
  data: string
} = {
  name: 'sourceOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128"/></svg>`,
}
export const civicTherapyOutline: {
  name: 'therapyOutline'
  data: string
} = {
  name: 'therapyOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="m353.2 404.1-158-158c-14.1-14.1-14.1-36.9 0-50.9 14.1-14.1 36.9-14.1 50.9 0l158 158c-19.7 13.4-37.1 30.6-50.9 50.9m327.4 523.1c228.3-92.6 339.9-353.7 246.6-583.8-103.8-256-411.9-356.2-645.7-215.7-17 10.2-22.6 32.4-12.3 49.4 10.2 17 32.4 22.6 49.4 12.3 70.6-42.4 154.8-60.5 237.1-50.9 308.2 35.8 446 415.5 222.2 639.3s-602.4 86-639.2-220.8c-9.8-81.9 7.3-165 49.3-236.1 10.1-17.1 4.4-39.2-12.7-49.3s-39.2-4.4-49.3 12.7C77.2 367 55.2 465.6 67.2 565.6c35.1 293.1 340.3 472.3 613.4 361.6m-32.8-551c-66.3-66.3-169-74-243.7-23.1l133.4 133.4c22.7 22.7 6.3 61.5-25.5 61.5-20 0-12.1 2.8-158.8-143.9-50.9 74.7-43.2 177.4 23.1 243.7 75 75 196.5 75 271.5 0s74.9-196.6 0-271.6"/></svg>`,
}
export const civicUserOutline: {
  name: 'userOutline'
  data: string
} = {
  name: 'userOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M895.2 870.4c-6.2-93.3-45.8-180.2-111.6-246-38.6-38.6-81.7-66.7-126.9-85.1C724 493.2 768 415.8 768 328c0-141.6-114.4-256-256-256S256 186.4 256 328c0 88.6 44.8 166.6 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.9 0 724.8 4.3 736-7.6 4.5-4.9 6.8-11.4 6.4-18"/></svg>`,
}
export const civicVariantOutline: {
  name: 'variantOutline'
  data: string
} = {
  name: 'variantOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 777.9C18.6 550.4 165.3 167 476 137.7v748.6c-84.6-8-166.3-44.8-229.9-108.4"/></svg>`,
}
export const civicVariantgroupOutline: {
  name: 'variantgroupOutline'
  data: string
} = {
  name: 'variantgroupOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M256 787.4V236.6c36-33.5 78.9-60.5 128-78.3v707.3c-46.1-16.6-89.6-42.5-128-78.2m320 95.2V141.4c44.3 7.6 87.7 23.2 128 47.2v646.7c-38.8 23.2-82 39.4-128 47.3"/></svg>`,
}
export const civicVarianttypeOutline: {
  name: 'varianttypeOutline'
  data: string
} = {
  name: 'varianttypeOutline',
  data: `<svg viewBox="0 0 1024 1024"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m72.6 318.7c1.9 3.1 101.9 167 104.9 172 51.7-6.2 97.5 34 97.5 86.4 0 48.1-39 87-87 87-70.2 0-110.9-78.8-72-135.9-2.8-4.5-103.4-169.6-104.5-171.3-52.4 6.9-98.5-33.8-98.5-86.2 0-48.1 39-87 87-87 69.7 0 110.5 77.8 72.6 135M136 512c0-207.7 168.3-376 376-376v73.7c-109.3 0-164.6 129.9-92.5 209.1l-84.3 136c-52.1-6.7-98.2 33.8-98.2 86.3 0 48.1 39 87 87 87 70 0 110.6-78.3 72.3-135.4l84.9-136.9c9.8 2.5 20.2 3.8 30.8 3.8V888c-207.7 0-376-168.3-376-376"/></svg>`,
}
export const civicAdminTwotone: {
  name: 'adminTwotone'
  data: string
} = {
  name: 'adminTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M895.2 870.4c-10.2-154.4-111-279-238.5-331.1C724.2 492.9 768 415.9 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 86.8 43 165.2 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.7 0 725.9 3.2 736-7.6 4.5-4.9 6.8-11.4 6.4-18"/><path fill="#333" d="M895.2 870.4c-10.2-154.4-111-279-238.5-331.1C724.2 492.9 768 415.9 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 86.8 43 165.2 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.7 0 725.9 3.2 736-7.6 4.5-4.9 6.8-11.4 6.4-18M328 328V192h368v136c0 164.8-199.4 244.9-314.1 130.1C347.1 423.4 328 377.2 328 328"/></svg>`,
}
export const civicAssertionTwotone: {
  name: 'assertionTwotone'
  data: string
} = {
  name: 'assertionTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128m0 420c-161.4 0-292-130.6-292-292s130.6-292 292-292 292 130.6 292 292-130.6 292-292 292m0-512c-121.6 0-220 98.4-220 220s98.4 220 220 220 220-98.4 220-220-98.4-220-220-220"/></svg>`,
}
export const civicClinicaltrialTwotone: {
  name: 'clinicaltrialTwotone'
  data: string
} = {
  name: 'clinicaltrialTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 183.4c181.5 0 328.6 146.9 328.6 328.6 0 181.5-146.9 328.6-328.6 328.6-180.6 0-328.6-146.1-328.6-328.6 0-181.5 146.9-328.6 328.6-328.6"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m36 745.5V301.4c0-19.9-16.1-36-36-36s-36 16.1-36 36v508.2c0 19.9 16.1 36 36 36 19.9-.1 36-16.2 36-36.1M290.5 664.2v-39c0-19.9-16.1-36-36-36s-36 16.1-36 36v39c0 19.9 16.1 36 36 36s36-16.1 36-36m128.8 114.2V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v329.3c0 19.9 16.1 36 36 36s36-16.2 36-36.1m258.8-.5V449.2c0-19.9-16.1-36-36-36s-36 16.1-36 36v328.7c0 19.9 16.1 36 36 36s36-16.1 36-36m130.1-119.1v-31.9c0-19.9-16.1-36-36-36s-36 16.1-36 36v31.9c0 19.9 16.1 36 36 36s36-16.1 36-36"/></svg>`,
}
export const civicCommentTwotone: {
  name: 'commentTwotone'
  data: string
} = {
  name: 'commentTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M200 128c-39.8 0-72 32.2-72 72v432c0 39.8 32.2 72 72 72h312v148c0 34.6 44.1 49.1 64.8 21.6L704 704h120c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72z"/><path fill="#333" d="M824 200c-.1 0-.1 432 0 432H668c-7.9 10.5-73 97.4-84 112V632H200c-.1 0 0 8.4 0-432 0-.1-13.7 0 624 0m-624-72c-39.8 0-72 32.2-72 72v432c0 39.8 32.2 72 72 72h312v148c0 34.6 44.1 49.1 64.8 21.6L704 704h120c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72zm184 288c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64 64 28.7 64 64m128-64c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64m192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64"/></svg>`,
}
export const civicCoordinatesystemTwotone: {
  name: 'coordinatesystemTwotone'
  data: string
} = {
  name: 'coordinatesystemTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 924c-55.6 0-109.6-10.9-160.4-32.4-49.1-20.7-93.1-50.5-131-88.3-37.8-37.8-67.6-81.9-88.3-131C110.9 621.6 100 567.6 100 512s10.9-109.6 32.4-160.4c20.7-49.1 50.5-93.1 88.3-131 37.8-37.8 81.9-67.6 131-88.3C402.4 110.9 456.4 100 512 100s109.6 10.9 160.4 32.4c49.1 20.7 93.1 50.5 131 88.3 37.8 37.8 67.6 81.9 88.3 131C913.1 402.4 924 456.4 924 512s-10.9 109.6-32.4 160.4c-20.7 49.1-50.5 93.1-88.3 131s-81.9 67.6-131 88.3C621.6 913.1 567.6 924 512 924"/><path fill="#1DB8A9" d="M512 136c50.8 0 100 9.9 146.3 29.5 44.8 18.9 85 46.1 119.5 80.6 34.6 34.6 61.7 74.8 80.6 119.5C878.1 412 888 461.2 888 512s-9.9 100-29.5 146.3c-18.9 44.8-46.1 85-80.6 119.5-34.6 34.6-74.8 61.7-119.5 80.6C612 878.1 562.8 888 512 888s-100-9.9-146.3-29.5c-44.8-18.9-85-46.1-119.5-80.6-34.6-34.6-61.7-74.8-80.6-119.5C145.9 612 136 562.8 136 512s9.9-100 29.5-146.3c18.9-44.8 46.1-85 80.6-119.5 34.6-34.6 74.8-61.7 119.5-80.6C412 145.9 461.2 136 512 136m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m375.9 440.8-154.7 55.4-81-225.9L807 278.8c49.3 62.2 79.3 140.6 80.9 226m-222.5 79.7-225.9 81-81-225.9 225.9-81zm86.2-362.3L628 266.5l-44.3-123.7c60.2 11.6 118.4 38.3 167.9 79.4m-246.8-86.1 55.4 154.7-225.9 81L278.8 217c62.2-49.3 140.6-79.3 226-80.9M222.2 272.4 266.5 396l-123.7 44.3c11.6-60.2 38.3-118.4 79.4-167.9m-86.1 246.8 154.7-55.4 81 225.9L217 745.2c-49.3-62.2-79.3-140.6-80.9-226m136.3 282.6L396 757.5l44.3 123.7c-60.2-11.6-118.4-38.3-167.9-79.4m246.8 86.1-55.4-154.7 225.9-81L745.2 807c-62.2 49.3-140.6 79.3-226 80.9m282.6-136.3L757.5 628l123.7-44.3c-11.6 60.2-38.3 118.4-79.4 167.9"/></svg>`,
}
export const civicCuratorTwotone: {
  name: 'curatorTwotone'
  data: string
} = {
  name: 'curatorTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 548c-121.6 0-220-98.4-220-220s98.4-220 220-220 220 98.4 220 220-98.4 220-220 220m348 348c0-192.4-155.7-348-348-348-192.4 0-348 155.7-348 348"/><path fill="#333" d="M655.8 539.9C862.9 399.3 764.6 72 512 72c-253.1 0-350.2 327.6-143.9 467.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.6 150.1-312 312-312 178.6 0 312 144.8 312 312 0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M328 328c0-101.8 82.2-184 184-184s184 82.2 184 184c0 98.5-77 178.7-174.2 183.7-6.5-.2-13.1-.2-19.7 0C404.9 506.6 328 426.5 328 328"/></svg>`,
}
export const civicDiseaseTwotone: {
  name: 'diseaseTwotone'
  data: string
} = {
  name: 'diseaseTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-79.1 225.9c-79 0-143.1 64.1-143.1 143.1s64.1 143 143.1 143S576 511.9 576 432.9s-64.1-143-143.1-143"/></svg>`,
}
export const civicEditorTwotone: {
  name: 'editorTwotone'
  data: string
} = {
  name: 'editorTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M164 896c0-192.3 155.6-348 348-348 192.3 0 348 155.6 348 348M732 328V108H292v220c0 121.6 98.4 220 220 220s220-98.4 220-220"/><path fill="#333" d="M655.8 539.9C723.6 493.9 768 416.2 768 328V151.4h64.3c24 0 43.4-19.4 43.4-43.4s-19.4-43.4-43.4-43.4H191.7c-24 0-43.4 19.4-43.4 43.4s19.4 43.4 43.4 43.4H256V328c0 88.2 44.4 165.8 112.1 211.8C225.9 597.4 128 736 128 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-182.7 147.1-306.4 303.7-312.1 6.5.2 11.8.2 19.4-.1C685 588 824 723.4 824 896c0 19.9 16.1 36 36 36s36-16.1 36-36c0-166.9-103.1-300.2-240.2-356.1M523 511.8c-8.1-.2-16.3-.2-24.5.1-92-6-170.5-84.2-170.5-183.9V192h368v136c0 105.3-83 177.5-173 183.8"/></svg>`,
}
export const civicEventTwotone: {
  name: 'eventTwotone'
  data: string
} = {
  name: 'eventTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m147.8 386.8L693 331l-119.8 33.2L512 256l-61.2 108.2L331 331l33.2 119.8L256 512l108.2 61.2L331 693l119.8-33.2L512 768l61.2-108.2L693 693l-33.2-119.8L768 512z"/></svg>`,
}
export const civicEvidenceTwotone: {
  name: 'evidenceTwotone'
  data: string
} = {
  name: 'evidenceTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicEvidenceitemTwotone: {
  name: 'evidenceitemTwotone'
  data: string
} = {
  name: 'evidenceitemTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M195.2 195.2c-175 175-175 458.6 0 633.6s458.6 175 633.6 0 175-458.6 0-633.6-458.6-174.9-633.6 0M476 137.7V476H137.7c17-179 159.4-321.3 338.3-338.3M137.7 548H476v338.3c-179-17-321.3-159.4-338.3-338.3M548 886.3V548h338.3c-17 179-159.4 321.3-338.3 338.3M886.3 476H548V137.7c179 17 321.3 159.4 338.3 338.3"/></svg>`,
}
export const civicFeatureTwotone: {
  name: 'featureTwotone'
  data: string
} = {
  name: 'featureTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 246.1C473.6 18.6 857 165.3 886.3 476H137.7c8-84.6 44.8-166.3 108.4-229.9"/></svg>`,
}
export const civicFlagTwotone: {
  name: 'flagTwotone'
  data: string
} = {
  name: 'flagTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M774.9 553.6c7.4 6.2 4.9 18.2-4.5 20.8L433.6 666c-6.4 1.7-13-2-14.7-8.4L341.2 372c-1.7-6.4 2-13 8.4-14.7C709 259.5 690.9 261 698.4 269c3 3.3 4 8 2.5 12.2-58.6 162.9-61 159.8-51.8 167.5zM960 512c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-72 0c0-207.7-168.3-376-376-376S136 304.3 136 512c0 157.7 96.9 292.6 234.5 348.5L241.6 386.6c-5.2-19.2 6.1-39 25.3-44.2s39 6.1 44.2 25.3l140.2 515.5c19.8 3.2 40.1 4.9 60.8 4.9C719.7 888 888 719.7 888 512"/></svg>`,
}
export const civicMolecularprofileTwotone: {
  name: 'molecularprofileTwotone'
  data: string
} = {
  name: 'molecularprofileTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m-17.4 72.4V494H136.4c9.1-193.6 164.7-348.9 358.2-357.6m36 751.2V530h357c-9 193.1-164 348.3-357 357.6"/></svg>`,
}
export const civicOrganizationTwotone: {
  name: 'organizationTwotone'
  data: string
} = {
  name: 'organizationTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M256.4 325.1c0-95.8 77.5-173.4 173.4-173.4 44 0 84.1 16.3 114.6 43.2C410.5 220.5 327 347.5 340.2 473.6c-50.3-30.3-83.8-85.5-83.8-148.5m134.9 275.6c-21.5-28.1-36-58.5-44.2-89.6-111.1 35-191.6 138.8-191.6 261.6h103.1c25.5-71.3 72.9-130.7 132.7-172m376.3-155.1c0-95.8-77.6-173.4-173.4-173.4s-173.4 77.6-173.4 173.4S498.4 619 594.2 619c95.9 0 173.4-77.5 173.4-173.4M320 893.3C320 741.7 442.7 619 594.3 619s274.3 122.7 274.3 274.3z"/><path fill="#333" d="M187.5 772.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 66 0 119.4 28.5 155.2 70.7-28.4 1-55 6.3-79.4 15.2-21.9-13.9-47.9-21.9-75.8-21.9-78.2 0-141.4 63.2-141.4 141.4 0 43.7 19.7 82.7 50.8 108.6-1.9 36.1 3.8 72.9 18.2 108.2-93.8 29.8-169.8 114.9-169.8 230.8m713 120.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-64.8-25.2-125.6-70.9-171.3C613.6 570 352 678 352 893.3c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-134 80.8-235.9 185.9-281.1-160.1-115.8-79.5-371.9 120.3-371.9 197.1 0 281.4 253.6 121.6 371 105.9 46.2 184.7 153.5 184.7 282M586.3 586.8c5.9-.2 11.9-.3 17.8-.1 73.6-5.1 131.5-66.1 131.5-141 0-78.2-63.2-141.4-141.4-141.4s-141.4 63.2-141.4 141.4c.1 75.5 59 137 133.5 141.1"/></svg>`,
}
export const civicPhenotypeTwotone: {
  name: 'phenotypeTwotone'
  data: string
} = {
  name: 'phenotypeTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M422.7 512c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96m537.3 0c0 247.4-200.6 448-448 448S64 759.4 64 512 264.6 64 512 64s448 200.6 448 448m-358.7 0c0 53 43 96 96 96s96-43 96-96-43-96-96-96-96 43-96 96M512 888V136c-207.7 0-376 168.3-376 376s168.3 376 376 376"/></svg>`,
}
export const civicQueueTwotone: {
  name: 'queueTwotone'
  data: string
} = {
  name: 'queueTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M674.7 791.2C656.4 864.1 590.5 918 512 918s-144.4-54-162.7-126.8c44.4 36.2 101 57.9 162.7 57.9s118.3-21.7 162.7-57.9M512 690.2c-61.7 0-118.3-21.7-162.7-57.9 18.3 72.9 84.2 126.8 162.7 126.8s144.4-54 162.7-126.8c-44.4 36.2-101 57.9-162.7 57.9m0-158.9c-61.7 0-118.3-21.7-162.7-57.9 18.3 72.9 84.2 126.8 162.7 126.8s144.4-54 162.7-126.8c-44.4 36.2-101 57.9-162.7 57.9m167.7-257.6c0-92.6-75.1-167.7-167.7-167.7s-167.7 75-167.7 167.7S419.4 441.4 512 441.4s167.7-75.1 167.7-167.7"/><path fill="none" d="M512 409.7v204.7"/><path fill="#333" d="M312.3 913.1C165.1 839.7 64 687.7 64 512s101.1-327.7 248.3-401.1c-28.6 35.1-48.2 77.8-55.1 124.6C182.7 304.2 136 402.6 136 512s46.6 207.8 121.1 276.5c7 46.8 26.6 89.6 55.2 124.6m454.6-677.6C841.4 304.2 888 402.6 888 512s-46.7 207.8-121.2 276.5c-7 46.8-26.5 89.6-55.1 124.6C858.9 839.7 960 687.7 960 512S858.9 184.3 711.7 110.9c28.6 35 48.2 77.8 55.2 124.6m-45.4 506C726.4 861.1 631 960 512 960c-119.1 0-214.4-99.1-209.5-218.5 23.6 32.9 54.7 59.9 90.8 78.7 53.4 90.6 184.2 90.1 237.3 0 36.2-18.8 67.3-45.8 90.9-78.7m-90.8-80.2c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-5 119.4 90.2 218.5 209.4 218.5 119 0 214.4-98.9 209.5-218.5-23.6 32.9-54.7 60-90.8 78.7m0-158.9c-53.1 90.1-183.9 90.6-237.3 0-36.1-18.8-67.2-45.8-90.8-78.7-4.9 119.4 90.3 218.5 209.5 218.5 119 0 214.4-98.9 209.5-218.5-23.7 32.9-54.8 60-90.9 78.7M374.3 273.7c0 76.1 61.6 137.7 137.7 137.7s137.7-61.6 137.7-137.7S588.1 136 512 136s-137.7 61.6-137.7 137.7m-72 0C302.3 157.9 396.2 64 512 64s209.7 93.9 209.7 209.7S627.8 483.3 512 483.3s-209.7-93.8-209.7-209.6"/></svg>`,
}
export const civicRevisionTwotone: {
  name: 'revisionTwotone'
  data: string
} = {
  name: 'revisionTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m281.4 341.9c14.1-14.1 14.1-36.9 0-50.9L669 230.6c-14.1-14.1-36.9-14.1-50.9 0L291.7 556.9l-18.7 181c-.4 3.6.9 7.2 3.5 9.7 2.6 2.6 6.1 3.8 9.7 3.5l180.9-18.7zm-76.3-25.4-39.6 39.6-73.5-73.5 39.6-39.6zM352.2 671.8l8.5-82L553 397.4l73.5 73.5-192.3 192.4z"/></svg>`,
}
export const civicSourceTwotone: {
  name: 'sourceTwotone'
  data: string
} = {
  name: 'sourceTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#E6E6E6" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64"/><path fill="#333" d="M512 136c207.7 0 376 168.3 376 376S719.7 888 512 888 136 719.7 136 512s168.3-376 376-376m0-72C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128"/></svg>`,
}
export const civicTherapyTwotone: {
  name: 'therapyTwotone'
  data: string
} = {
  name: 'therapyTwotone',
  data: `<svg viewBox="0 0 1024 1024"><ellipse cx="512" cy="512" fill="#E6E6E6" rx="416" ry="412" transform="rotate(-45.001 511.997 512.008)"/><path fill="#333" d="m353.2 404.1-158-158c-14.1-14.1-14.1-36.9 0-50.9 14.1-14.1 36.9-14.1 50.9 0l158 158c-19.7 13.4-37.1 30.6-50.9 50.9m327.4 523.1c228.3-92.6 339.9-353.7 246.6-583.8-103.8-256-411.9-356.2-645.7-215.7-17 10.2-22.6 32.4-12.3 49.4 10.2 17 32.4 22.6 49.4 12.3 70.6-42.4 154.8-60.5 237.1-50.9 308.2 35.8 446 415.5 222.2 639.3s-602.4 86-639.2-220.8c-9.8-81.9 7.3-165 49.3-236.1 10.1-17.1 4.4-39.2-12.7-49.3s-39.2-4.4-49.3 12.7C77.2 367 55.2 465.6 67.2 565.6c35.1 293.1 340.3 472.3 613.4 361.6m-32.8-551c-66.3-66.3-169-74-243.7-23.1l133.4 133.4c22.7 22.7 6.3 61.5-25.5 61.5-20 0-12.1 2.8-158.8-143.9-50.9 74.7-43.2 177.4 23.1 243.7 75 75 196.5 75 271.5 0s74.9-196.6 0-271.6"/></svg>`,
}
export const civicUserTwotone: {
  name: 'userTwotone'
  data: string
} = {
  name: 'userTwotone',
  data: `<svg viewBox="0 0 1024 1024"><path fill="#333" d="M895.2 870.4c-6.2-93.3-45.8-180.2-111.6-246-38.6-38.6-81.7-66.7-126.9-85.1C724 493.2 768 415.8 768 328c0-141.6-114.4-256-256-256S256 186.4 256 328c0 88.6 44.8 166.6 113.1 212.5-128.7 51.9-230.4 170.8-240.3 330-.9 13.9 10.2 25.5 24 25.5 782.9 0 724.8 4.3 736-7.6 4.5-4.9 6.8-11.4 6.4-18"/></svg>`,
}
export const civicVariantTwotone: {
  name: 'variantTwotone'
  data: string
} = {
  name: 'variantTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M246.1 777.9C18.7 550.4 165.3 167 476 137.7v748.6c-84.6-8-166.3-44.8-229.9-108.4"/></svg>`,
}
export const civicVariantgroupTwotone: {
  name: 'variantgroupTwotone'
  data: string
} = {
  name: 'variantgroupTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64M256 787.4V236.6c36-33.5 78.9-60.5 128-78.3v707.3c-46.1-16.6-89.6-42.5-128-78.2m320 95.2V141.4c44.3 7.6 87.7 23.2 128 47.2v646.7c-38.8 23.2-82 39.4-128 47.3"/></svg>`,
}
export const civicVarianttypeTwotone: {
  name: 'varianttypeTwotone'
  data: string
} = {
  name: 'varianttypeTwotone',
  data: `<svg viewBox="0 0 1024 1024"><circle cx="512" cy="512" r="448" fill="#E0F4E6"/><path fill="#33B358" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m72.6 318.7c1.9 3.1 101.9 167 104.9 172 51.7-6.2 97.5 34 97.5 86.4 0 48.1-39 87-87 87-70.2 0-110.9-78.8-72-135.9-2.8-4.5-103.4-169.6-104.5-171.3-52.4 6.9-98.5-33.8-98.5-86.2 0-48.1 39-87 87-87 69.7 0 110.5 77.8 72.6 135M136 512c0-207.7 168.3-376 376-376v73.7c-109.3 0-164.6 129.9-92.5 209.1l-84.3 136c-52.1-6.7-98.2 33.8-98.2 86.3 0 48.1 39 87 87 87 70 0 110.6-78.3 72.3-135.4l84.9-136.9c9.8 2.5 20.2 3.8 30.8 3.8V888c-207.7 0-376-168.3-376-376"/><circle cx="512" cy="512" r="448" fill="#E6E6E6"/><path fill="#333" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m72.6 318.7c1.9 3.1 101.9 167 104.9 172 51.7-6.2 97.5 34 97.5 86.4 0 48.1-39 87-87 87-70.2 0-110.9-78.8-72-135.9-2.8-4.5-103.4-169.6-104.5-171.3-52.4 6.9-98.5-33.8-98.5-86.2 0-48.1 39-87 87-87 69.7 0 110.5 77.8 72.6 135M136 512c0-207.7 168.3-376 376-376v73.7c-109.3 0-164.6 129.9-92.5 209.1l-84.3 136c-52.1-6.7-98.2 33.8-98.2 86.3 0 48.1 39 87 87 87 70 0 110.6-78.3 72.3-135.4l84.9-136.9c9.8 2.5 20.2 3.8 30.8 3.8V888c-207.7 0-376-168.3-376-376"/></svg>`,
}
export type CivicIcon =
  | 'adverseresponseOutline'
  | 'benignOutline'
  | 'betteroutcomeOutline'
  | 'combinationOutline'
  | 'combinedOutline'
  | 'commongermlineOutline'
  | 'diagnosticOutline'
  | 'doesnotsupportOutline'
  | 'dominantnegativeOutline'
  | 'functionalOutline'
  | 'gainoffunctionOutline'
  | 'levelaOutline'
  | 'levelbOutline'
  | 'levelcOutline'
  | 'leveldOutline'
  | 'leveleOutline'
  | 'likelybenignOutline'
  | 'likelyoncogenicOutline'
  | 'likelypathogenicOutline'
  | 'lossoffunctionOutline'
  | 'mixedOutline'
  | 'mixed'
  | 'naOutline'
  | 'negativeOutline'
  | 'neomorphicOutline'
  | 'oncogenicOutline'
  | 'oncogenicityOutline'
  | 'oncogenicsignificanceOutline'
  | 'oncogenictypeOutline'
  | 'pathogenicOutline'
  | 'pooroutcomeOutline'
  | 'positiveOutline'
  | 'predictiveOutline'
  | 'predisposingOutline'
  | 'predispositionOutline'
  | 'prognosticOutline'
  | 'protectivenessOutline'
  | 'raregermlineOutline'
  | 'rating1Outline'
  | 'rating2Outline'
  | 'rating3Outline'
  | 'rating4Outline'
  | 'rating5Outline'
  | 'reducedsensitivityOutline'
  | 'resistanceOutline'
  | 'sensitivityresponseOutline'
  | 'sequentialOutline'
  | 'significanceunknownOutline'
  | 'somaticOutline'
  | 'substitutesOutline'
  | 'supportsOutline'
  | 'unalteredfunctionOutline'
  | 'uncertainsignificanceOutline'
  | 'unknownOutline'
  | 'adminFullcolor'
  | 'assertionFullcolor'
  | 'clinicaltrialFullcolor'
  | 'commentFullcolor'
  | 'coordinatesystemFullcolor'
  | 'curatorFullcolor'
  | 'diseaseFullcolor'
  | 'editorFullcolor'
  | 'eventFullcolor'
  | 'evidenceFullcolor'
  | 'evidenceitemFullcolor'
  | 'featureFullcolor'
  | 'flagFullcolor'
  | 'molecularprofileFullcolor'
  | 'organizationFullcolor'
  | 'phenotypeFullcolor'
  | 'queueFullcolor'
  | 'revisionFullcolor'
  | 'sourceFullcolor'
  | 'therapyFullcolor'
  | 'userFullcolor'
  | 'variant'
  | 'variantgroupFullcolor'
  | 'varianttypeFullcolor'
  | 'orcid'
  | 'adminOutline'
  | 'assertionOutline'
  | 'clinicaltrialOutline'
  | 'commentOutline'
  | 'coordinatesystemOutline'
  | 'curatorOutline'
  | 'diseaseOutline'
  | 'editorOutline'
  | 'eventOutline'
  | 'evidenceOutline'
  | 'evidenceitemOutline'
  | 'featureOutline'
  | 'flagOutline'
  | 'molecularprofileOutline'
  | 'organizationOutline'
  | 'phenotypeOutline'
  | 'queueOutline'
  | 'revisionOutline'
  | 'sourceOutline'
  | 'therapyOutline'
  | 'userOutline'
  | 'variantOutline'
  | 'variantgroupOutline'
  | 'varianttypeOutline'
  | 'adminTwotone'
  | 'assertionTwotone'
  | 'clinicaltrialTwotone'
  | 'commentTwotone'
  | 'coordinatesystemTwotone'
  | 'curatorTwotone'
  | 'diseaseTwotone'
  | 'editorTwotone'
  | 'eventTwotone'
  | 'evidenceTwotone'
  | 'evidenceitemTwotone'
  | 'featureTwotone'
  | 'flagTwotone'
  | 'molecularprofileTwotone'
  | 'organizationTwotone'
  | 'phenotypeTwotone'
  | 'queueTwotone'
  | 'revisionTwotone'
  | 'sourceTwotone'
  | 'therapyTwotone'
  | 'userTwotone'
  | 'variantTwotone'
  | 'variantgroupTwotone'
  | 'varianttypeTwotone'
export const CivicIcon = {
  adverseresponseOutline: 'adverseresponseOutline' as CivicIcon,
  benignOutline: 'benignOutline' as CivicIcon,
  betteroutcomeOutline: 'betteroutcomeOutline' as CivicIcon,
  combinationOutline: 'combinationOutline' as CivicIcon,
  combinedOutline: 'combinedOutline' as CivicIcon,
  commongermlineOutline: 'commongermlineOutline' as CivicIcon,
  diagnosticOutline: 'diagnosticOutline' as CivicIcon,
  doesnotsupportOutline: 'doesnotsupportOutline' as CivicIcon,
  dominantnegativeOutline: 'dominantnegativeOutline' as CivicIcon,
  functionalOutline: 'functionalOutline' as CivicIcon,
  gainoffunctionOutline: 'gainoffunctionOutline' as CivicIcon,
  levelaOutline: 'levelaOutline' as CivicIcon,
  levelbOutline: 'levelbOutline' as CivicIcon,
  levelcOutline: 'levelcOutline' as CivicIcon,
  leveldOutline: 'leveldOutline' as CivicIcon,
  leveleOutline: 'leveleOutline' as CivicIcon,
  likelybenignOutline: 'likelybenignOutline' as CivicIcon,
  likelyoncogenicOutline: 'likelyoncogenicOutline' as CivicIcon,
  likelypathogenicOutline: 'likelypathogenicOutline' as CivicIcon,
  lossoffunctionOutline: 'lossoffunctionOutline' as CivicIcon,
  mixedOutline: 'mixedOutline' as CivicIcon,
  mixed: 'mixed' as CivicIcon,
  naOutline: 'naOutline' as CivicIcon,
  negativeOutline: 'negativeOutline' as CivicIcon,
  neomorphicOutline: 'neomorphicOutline' as CivicIcon,
  oncogenicOutline: 'oncogenicOutline' as CivicIcon,
  oncogenicityOutline: 'oncogenicityOutline' as CivicIcon,
  oncogenicsignificanceOutline: 'oncogenicsignificanceOutline' as CivicIcon,
  oncogenictypeOutline: 'oncogenictypeOutline' as CivicIcon,
  pathogenicOutline: 'pathogenicOutline' as CivicIcon,
  pooroutcomeOutline: 'pooroutcomeOutline' as CivicIcon,
  positiveOutline: 'positiveOutline' as CivicIcon,
  predictiveOutline: 'predictiveOutline' as CivicIcon,
  predisposingOutline: 'predisposingOutline' as CivicIcon,
  predispositionOutline: 'predispositionOutline' as CivicIcon,
  prognosticOutline: 'prognosticOutline' as CivicIcon,
  protectivenessOutline: 'protectivenessOutline' as CivicIcon,
  raregermlineOutline: 'raregermlineOutline' as CivicIcon,
  rating1Outline: 'rating1Outline' as CivicIcon,
  rating2Outline: 'rating2Outline' as CivicIcon,
  rating3Outline: 'rating3Outline' as CivicIcon,
  rating4Outline: 'rating4Outline' as CivicIcon,
  rating5Outline: 'rating5Outline' as CivicIcon,
  reducedsensitivityOutline: 'reducedsensitivityOutline' as CivicIcon,
  resistanceOutline: 'resistanceOutline' as CivicIcon,
  sensitivityresponseOutline: 'sensitivityresponseOutline' as CivicIcon,
  sequentialOutline: 'sequentialOutline' as CivicIcon,
  significanceunknownOutline: 'significanceunknownOutline' as CivicIcon,
  somaticOutline: 'somaticOutline' as CivicIcon,
  substitutesOutline: 'substitutesOutline' as CivicIcon,
  supportsOutline: 'supportsOutline' as CivicIcon,
  unalteredfunctionOutline: 'unalteredfunctionOutline' as CivicIcon,
  uncertainsignificanceOutline: 'uncertainsignificanceOutline' as CivicIcon,
  unknownOutline: 'unknownOutline' as CivicIcon,
  adminFullcolor: 'adminFullcolor' as CivicIcon,
  assertionFullcolor: 'assertionFullcolor' as CivicIcon,
  clinicaltrialFullcolor: 'clinicaltrialFullcolor' as CivicIcon,
  commentFullcolor: 'commentFullcolor' as CivicIcon,
  coordinatesystemFullcolor: 'coordinatesystemFullcolor' as CivicIcon,
  curatorFullcolor: 'curatorFullcolor' as CivicIcon,
  diseaseFullcolor: 'diseaseFullcolor' as CivicIcon,
  editorFullcolor: 'editorFullcolor' as CivicIcon,
  eventFullcolor: 'eventFullcolor' as CivicIcon,
  evidenceFullcolor: 'evidenceFullcolor' as CivicIcon,
  evidenceitemFullcolor: 'evidenceitemFullcolor' as CivicIcon,
  featureFullcolor: 'featureFullcolor' as CivicIcon,
  flagFullcolor: 'flagFullcolor' as CivicIcon,
  molecularprofileFullcolor: 'molecularprofileFullcolor' as CivicIcon,
  organizationFullcolor: 'organizationFullcolor' as CivicIcon,
  phenotypeFullcolor: 'phenotypeFullcolor' as CivicIcon,
  queueFullcolor: 'queueFullcolor' as CivicIcon,
  revisionFullcolor: 'revisionFullcolor' as CivicIcon,
  sourceFullcolor: 'sourceFullcolor' as CivicIcon,
  therapyFullcolor: 'therapyFullcolor' as CivicIcon,
  userFullcolor: 'userFullcolor' as CivicIcon,
  variant: 'variant' as CivicIcon,
  variantgroupFullcolor: 'variantgroupFullcolor' as CivicIcon,
  varianttypeFullcolor: 'varianttypeFullcolor' as CivicIcon,
  orcid: 'orcid' as CivicIcon,
  adminOutline: 'adminOutline' as CivicIcon,
  assertionOutline: 'assertionOutline' as CivicIcon,
  clinicaltrialOutline: 'clinicaltrialOutline' as CivicIcon,
  commentOutline: 'commentOutline' as CivicIcon,
  coordinatesystemOutline: 'coordinatesystemOutline' as CivicIcon,
  curatorOutline: 'curatorOutline' as CivicIcon,
  diseaseOutline: 'diseaseOutline' as CivicIcon,
  editorOutline: 'editorOutline' as CivicIcon,
  eventOutline: 'eventOutline' as CivicIcon,
  evidenceOutline: 'evidenceOutline' as CivicIcon,
  evidenceitemOutline: 'evidenceitemOutline' as CivicIcon,
  featureOutline: 'featureOutline' as CivicIcon,
  flagOutline: 'flagOutline' as CivicIcon,
  molecularprofileOutline: 'molecularprofileOutline' as CivicIcon,
  organizationOutline: 'organizationOutline' as CivicIcon,
  phenotypeOutline: 'phenotypeOutline' as CivicIcon,
  queueOutline: 'queueOutline' as CivicIcon,
  revisionOutline: 'revisionOutline' as CivicIcon,
  sourceOutline: 'sourceOutline' as CivicIcon,
  therapyOutline: 'therapyOutline' as CivicIcon,
  userOutline: 'userOutline' as CivicIcon,
  variantOutline: 'variantOutline' as CivicIcon,
  variantgroupOutline: 'variantgroupOutline' as CivicIcon,
  varianttypeOutline: 'varianttypeOutline' as CivicIcon,
  adminTwotone: 'adminTwotone' as CivicIcon,
  assertionTwotone: 'assertionTwotone' as CivicIcon,
  clinicaltrialTwotone: 'clinicaltrialTwotone' as CivicIcon,
  commentTwotone: 'commentTwotone' as CivicIcon,
  coordinatesystemTwotone: 'coordinatesystemTwotone' as CivicIcon,
  curatorTwotone: 'curatorTwotone' as CivicIcon,
  diseaseTwotone: 'diseaseTwotone' as CivicIcon,
  editorTwotone: 'editorTwotone' as CivicIcon,
  eventTwotone: 'eventTwotone' as CivicIcon,
  evidenceTwotone: 'evidenceTwotone' as CivicIcon,
  evidenceitemTwotone: 'evidenceitemTwotone' as CivicIcon,
  featureTwotone: 'featureTwotone' as CivicIcon,
  flagTwotone: 'flagTwotone' as CivicIcon,
  molecularprofileTwotone: 'molecularprofileTwotone' as CivicIcon,
  organizationTwotone: 'organizationTwotone' as CivicIcon,
  phenotypeTwotone: 'phenotypeTwotone' as CivicIcon,
  queueTwotone: 'queueTwotone' as CivicIcon,
  revisionTwotone: 'revisionTwotone' as CivicIcon,
  sourceTwotone: 'sourceTwotone' as CivicIcon,
  therapyTwotone: 'therapyTwotone' as CivicIcon,
  userTwotone: 'userTwotone' as CivicIcon,
  variantTwotone: 'variantTwotone' as CivicIcon,
  variantgroupTwotone: 'variantgroupTwotone' as CivicIcon,
  varianttypeTwotone: 'varianttypeTwotone' as CivicIcon,
}
export interface CivicIconLiteral {
  name: CivicIcon
  data: string
}
export type CivicIconLiteralNameSubset<T extends Readonly<CivicIconLiteral[]>> =
  T[number]['name']
export const completeIconSet = [
  civicAdverseresponseOutline,
  civicBenignOutline,
  civicBetteroutcomeOutline,
  civicCombinationOutline,
  civicCombinedOutline,
  civicCommongermlineOutline,
  civicDiagnosticOutline,
  civicDoesnotsupportOutline,
  civicDominantnegativeOutline,
  civicFunctionalOutline,
  civicGainoffunctionOutline,
  civicLevelaOutline,
  civicLevelbOutline,
  civicLevelcOutline,
  civicLeveldOutline,
  civicLeveleOutline,
  civicLikelybenignOutline,
  civicLikelyoncogenicOutline,
  civicLikelypathogenicOutline,
  civicLossoffunctionOutline,
  civicMixedOutline,
  civicMixed,
  civicNaOutline,
  civicNegativeOutline,
  civicNeomorphicOutline,
  civicOncogenicOutline,
  civicOncogenicityOutline,
  civicOncogenicsignificanceOutline,
  civicOncogenictypeOutline,
  civicPathogenicOutline,
  civicPooroutcomeOutline,
  civicPositiveOutline,
  civicPredictiveOutline,
  civicPredisposingOutline,
  civicPredispositionOutline,
  civicPrognosticOutline,
  civicProtectivenessOutline,
  civicRaregermlineOutline,
  civicRating1Outline,
  civicRating2Outline,
  civicRating3Outline,
  civicRating4Outline,
  civicRating5Outline,
  civicReducedsensitivityOutline,
  civicResistanceOutline,
  civicSensitivityresponseOutline,
  civicSequentialOutline,
  civicSignificanceunknownOutline,
  civicSomaticOutline,
  civicSubstitutesOutline,
  civicSupportsOutline,
  civicUnalteredfunctionOutline,
  civicUncertainsignificanceOutline,
  civicUnknownOutline,
  civicAdminFullcolor,
  civicAssertionFullcolor,
  civicClinicaltrialFullcolor,
  civicCommentFullcolor,
  civicCoordinatesystemFullcolor,
  civicCuratorFullcolor,
  civicDiseaseFullcolor,
  civicEditorFullcolor,
  civicEventFullcolor,
  civicEvidenceFullcolor,
  civicEvidenceitemFullcolor,
  civicFeatureFullcolor,
  civicFlagFullcolor,
  civicMolecularprofileFullcolor,
  civicOrganizationFullcolor,
  civicPhenotypeFullcolor,
  civicQueueFullcolor,
  civicRevisionFullcolor,
  civicSourceFullcolor,
  civicTherapyFullcolor,
  civicUserFullcolor,
  civicVariant,
  civicVariantgroupFullcolor,
  civicVarianttypeFullcolor,
  civicOrcid,
  civicAdminOutline,
  civicAssertionOutline,
  civicClinicaltrialOutline,
  civicCommentOutline,
  civicCoordinatesystemOutline,
  civicCuratorOutline,
  civicDiseaseOutline,
  civicEditorOutline,
  civicEventOutline,
  civicEvidenceOutline,
  civicEvidenceitemOutline,
  civicFeatureOutline,
  civicFlagOutline,
  civicMolecularprofileOutline,
  civicOrganizationOutline,
  civicPhenotypeOutline,
  civicQueueOutline,
  civicRevisionOutline,
  civicSourceOutline,
  civicTherapyOutline,
  civicUserOutline,
  civicVariantOutline,
  civicVariantgroupOutline,
  civicVarianttypeOutline,
  civicAdminTwotone,
  civicAssertionTwotone,
  civicClinicaltrialTwotone,
  civicCommentTwotone,
  civicCoordinatesystemTwotone,
  civicCuratorTwotone,
  civicDiseaseTwotone,
  civicEditorTwotone,
  civicEventTwotone,
  civicEvidenceTwotone,
  civicEvidenceitemTwotone,
  civicFeatureTwotone,
  civicFlagTwotone,
  civicMolecularprofileTwotone,
  civicOrganizationTwotone,
  civicPhenotypeTwotone,
  civicQueueTwotone,
  civicRevisionTwotone,
  civicSourceTwotone,
  civicTherapyTwotone,
  civicUserTwotone,
  civicVariantTwotone,
  civicVariantgroupTwotone,
  civicVarianttypeTwotone,
]
